import { jsx as e, jsxs as t, Fragment as n } from "react/jsx-runtime";
import r, { createContext as i, useState as o, useMemo as a, useCallback as s, useEffect as l, useRef as c, useDebugValue as d, useContext as u, createElement as f, memo as h } from "react";
import m from "react-dom";
"undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self;
function p(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var g = {
  exports: {}
};
g.exports = function () {
  var e = 1e3,
    t = 6e4,
    n = 36e5,
    r = "millisecond",
    i = "second",
    o = "minute",
    a = "hour",
    s = "day",
    l = "week",
    c = "month",
    d = "quarter",
    u = "year",
    f = "date",
    h = "Invalid Date",
    m = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,
    p = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,
    g = {
      name: "en",
      weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
      months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
      ordinal: function ordinal(e) {
        var t = ["th", "st", "nd", "rd"],
          n = e % 100;
        return "[" + e + (t[(n - 20) % 10] || t[n] || t[0]) + "]";
      }
    },
    v = function v(e, t, n) {
      var r = String(e);
      return !r || r.length >= t ? e : "" + Array(t + 1 - r.length).join(n) + e;
    },
    y = {
      s: v,
      z: function z(e) {
        var t = -e.utcOffset(),
          n = Math.abs(t),
          r = Math.floor(n / 60),
          i = n % 60;
        return (t <= 0 ? "+" : "-") + v(r, 2, "0") + ":" + v(i, 2, "0");
      },
      m: function e(t, n) {
        if (t.date() < n.date()) return -e(n, t);
        var r = 12 * (n.year() - t.year()) + (n.month() - t.month()),
          i = t.clone().add(r, c),
          o = n - i < 0,
          a = t.clone().add(r + (o ? -1 : 1), c);
        return +(-(r + (n - i) / (o ? i - a : a - i)) || 0);
      },
      a: function a(e) {
        return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
      },
      p: function p(e) {
        return {
          M: c,
          y: u,
          w: l,
          d: s,
          D: f,
          h: a,
          m: o,
          s: i,
          ms: r,
          Q: d
        }[e] || String(e || "").toLowerCase().replace(/s$/, "");
      },
      u: function u(e) {
        return void 0 === e;
      }
    },
    b = "en",
    w = {};
  w[b] = g;
  var C = function C(e) {
      return e instanceof N;
    },
    x = function e(t, n, r) {
      var i;
      if (!t) return b;
      if ("string" == typeof t) {
        var o = t.toLowerCase();
        w[o] && (i = o), n && (w[o] = n, i = o);
        var a = t.split("-");
        if (!i && a.length > 1) return e(a[0]);
      } else {
        var s = t.name;
        w[s] = t, i = s;
      }
      return !r && i && (b = i), i || !r && b;
    },
    S = function S(e, t) {
      if (C(e)) return e.clone();
      var n = "object" == typeof t ? t : {};
      return n.date = e, n.args = arguments, new N(n);
    },
    k = y;
  k.l = x, k.i = C, k.w = function (e, t) {
    return S(e, {
      locale: t.$L,
      utc: t.$u,
      x: t.$x,
      $offset: t.$offset
    });
  };
  var N = function () {
      function g(e) {
        this.$L = x(e.locale, null, !0), this.parse(e);
      }
      var v = g.prototype;
      return v.parse = function (e) {
        this.$d = function (e) {
          var t = e.date,
            n = e.utc;
          if (null === t) return new Date(NaN);
          if (k.u(t)) return new Date();
          if (t instanceof Date) return new Date(t);
          if ("string" == typeof t && !/Z$/i.test(t)) {
            var r = t.match(m);
            if (r) {
              var i = r[2] - 1 || 0,
                o = (r[7] || "0").substring(0, 3);
              return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, o)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, o);
            }
          }
          return new Date(t);
        }(e), this.$x = e.x || {}, this.init();
      }, v.init = function () {
        var e = this.$d;
        this.$y = e.getFullYear(), this.$M = e.getMonth(), this.$D = e.getDate(), this.$W = e.getDay(), this.$H = e.getHours(), this.$m = e.getMinutes(), this.$s = e.getSeconds(), this.$ms = e.getMilliseconds();
      }, v.$utils = function () {
        return k;
      }, v.isValid = function () {
        return !(this.$d.toString() === h);
      }, v.isSame = function (e, t) {
        var n = S(e);
        return this.startOf(t) <= n && n <= this.endOf(t);
      }, v.isAfter = function (e, t) {
        return S(e) < this.startOf(t);
      }, v.isBefore = function (e, t) {
        return this.endOf(t) < S(e);
      }, v.$g = function (e, t, n) {
        return k.u(e) ? this[t] : this.set(n, e);
      }, v.unix = function () {
        return Math.floor(this.valueOf() / 1e3);
      }, v.valueOf = function () {
        return this.$d.getTime();
      }, v.startOf = function (e, t) {
        var n = this,
          r = !!k.u(t) || t,
          d = k.p(e),
          h = function h(e, t) {
            var i = k.w(n.$u ? Date.UTC(n.$y, t, e) : new Date(n.$y, t, e), n);
            return r ? i : i.endOf(s);
          },
          m = function m(e, t) {
            return k.w(n.toDate()[e].apply(n.toDate("s"), (r ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(t)), n);
          },
          p = this.$W,
          g = this.$M,
          v = this.$D,
          y = "set" + (this.$u ? "UTC" : "");
        switch (d) {
          case u:
            return r ? h(1, 0) : h(31, 11);
          case c:
            return r ? h(1, g) : h(0, g + 1);
          case l:
            var b = this.$locale().weekStart || 0,
              w = (p < b ? p + 7 : p) - b;
            return h(r ? v - w : v + (6 - w), g);
          case s:
          case f:
            return m(y + "Hours", 0);
          case a:
            return m(y + "Minutes", 1);
          case o:
            return m(y + "Seconds", 2);
          case i:
            return m(y + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, v.endOf = function (e) {
        return this.startOf(e, !1);
      }, v.$set = function (e, t) {
        var n,
          l = k.p(e),
          d = "set" + (this.$u ? "UTC" : ""),
          h = (n = {}, n[s] = d + "Date", n[f] = d + "Date", n[c] = d + "Month", n[u] = d + "FullYear", n[a] = d + "Hours", n[o] = d + "Minutes", n[i] = d + "Seconds", n[r] = d + "Milliseconds", n)[l],
          m = l === s ? this.$D + (t - this.$W) : t;
        if (l === c || l === u) {
          var p = this.clone().set(f, 1);
          p.$d[h](m), p.init(), this.$d = p.set(f, Math.min(this.$D, p.daysInMonth())).$d;
        } else h && this.$d[h](m);
        return this.init(), this;
      }, v.set = function (e, t) {
        return this.clone().$set(e, t);
      }, v.get = function (e) {
        return this[k.p(e)]();
      }, v.add = function (r, d) {
        var f,
          h = this;
        r = Number(r);
        var m = k.p(d),
          p = function p(e) {
            var t = S(h);
            return k.w(t.date(t.date() + Math.round(e * r)), h);
          };
        if (m === c) return this.set(c, this.$M + r);
        if (m === u) return this.set(u, this.$y + r);
        if (m === s) return p(1);
        if (m === l) return p(7);
        var g = (f = {}, f[o] = t, f[a] = n, f[i] = e, f)[m] || 1,
          v = this.$d.getTime() + r * g;
        return k.w(v, this);
      }, v.subtract = function (e, t) {
        return this.add(-1 * e, t);
      }, v.format = function (e) {
        var t = this,
          n = this.$locale();
        if (!this.isValid()) return n.invalidDate || h;
        var r = e || "YYYY-MM-DDTHH:mm:ssZ",
          i = k.z(this),
          o = this.$H,
          a = this.$m,
          s = this.$M,
          l = n.weekdays,
          c = n.months,
          d = function d(e, n, i, o) {
            return e && (e[n] || e(t, r)) || i[n].slice(0, o);
          },
          u = function u(e) {
            return k.s(o % 12 || 12, e, "0");
          },
          f = n.meridiem || function (e, t, n) {
            var r = e < 12 ? "AM" : "PM";
            return n ? r.toLowerCase() : r;
          },
          m = {
            YY: String(this.$y).slice(-2),
            YYYY: this.$y,
            M: s + 1,
            MM: k.s(s + 1, 2, "0"),
            MMM: d(n.monthsShort, s, c, 3),
            MMMM: d(c, s),
            D: this.$D,
            DD: k.s(this.$D, 2, "0"),
            d: String(this.$W),
            dd: d(n.weekdaysMin, this.$W, l, 2),
            ddd: d(n.weekdaysShort, this.$W, l, 3),
            dddd: l[this.$W],
            H: String(o),
            HH: k.s(o, 2, "0"),
            h: u(1),
            hh: u(2),
            a: f(o, a, !0),
            A: f(o, a, !1),
            m: String(a),
            mm: k.s(a, 2, "0"),
            s: String(this.$s),
            ss: k.s(this.$s, 2, "0"),
            SSS: k.s(this.$ms, 3, "0"),
            Z: i
          };
        return r.replace(p, function (e, t) {
          return t || m[e] || i.replace(":", "");
        });
      }, v.utcOffset = function () {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, v.diff = function (r, f, h) {
        var m,
          p = k.p(f),
          g = S(r),
          v = (g.utcOffset() - this.utcOffset()) * t,
          y = this - g,
          b = k.m(this, g);
        return b = (m = {}, m[u] = b / 12, m[c] = b, m[d] = b / 3, m[l] = (y - v) / 6048e5, m[s] = (y - v) / 864e5, m[a] = y / n, m[o] = y / t, m[i] = y / e, m)[p] || y, h ? b : k.a(b);
      }, v.daysInMonth = function () {
        return this.endOf(c).$D;
      }, v.$locale = function () {
        return w[this.$L];
      }, v.locale = function (e, t) {
        if (!e) return this.$L;
        var n = this.clone(),
          r = x(e, t, !0);
        return r && (n.$L = r), n;
      }, v.clone = function () {
        return k.w(this.$d, this);
      }, v.toDate = function () {
        return new Date(this.valueOf());
      }, v.toJSON = function () {
        return this.isValid() ? this.toISOString() : null;
      }, v.toISOString = function () {
        return this.$d.toISOString();
      }, v.toString = function () {
        return this.$d.toUTCString();
      }, g;
    }(),
    A = N.prototype;
  return S.prototype = A, [["$ms", r], ["$s", i], ["$m", o], ["$H", a], ["$W", s], ["$M", c], ["$y", u], ["$D", f]].forEach(function (e) {
    A[e[1]] = function (t) {
      return this.$g(t, e[0], e[1]);
    };
  }), S.extend = function (e, t) {
    return e.$i || (e(t, N, S), e.$i = !0), S;
  }, S.locale = x, S.isDayjs = C, S.unix = function (e) {
    return S(1e3 * e);
  }, S.en = w[b], S.Ls = w, S.p = {}, S;
}();
var v = p(g.exports);
!function () {
  function e(e) {
    var t = !0,
      n = !1,
      r = null,
      i = {
        text: !0,
        search: !0,
        url: !0,
        tel: !0,
        email: !0,
        password: !0,
        number: !0,
        date: !0,
        month: !0,
        week: !0,
        time: !0,
        datetime: !0,
        "datetime-local": !0
      };
    function o(e) {
      return !!(e && e !== document && "HTML" !== e.nodeName && "BODY" !== e.nodeName && "classList" in e && "contains" in e.classList);
    }
    function a(e) {
      var t = e.type,
        n = e.tagName;
      return !("INPUT" !== n || !i[t] || e.readOnly) || "TEXTAREA" === n && !e.readOnly || !!e.isContentEditable;
    }
    function s(e) {
      e.classList.contains("focus-visible") || (e.classList.add("focus-visible"), e.setAttribute("data-focus-visible-added", ""));
    }
    function l(e) {
      e.hasAttribute("data-focus-visible-added") && (e.classList.remove("focus-visible"), e.removeAttribute("data-focus-visible-added"));
    }
    function c(n) {
      n.metaKey || n.altKey || n.ctrlKey || (o(e.activeElement) && s(e.activeElement), t = !0);
    }
    function d(e) {
      t = !1;
    }
    function u(e) {
      o(e.target) && (t || a(e.target)) && s(e.target);
    }
    function f(e) {
      o(e.target) && (e.target.classList.contains("focus-visible") || e.target.hasAttribute("data-focus-visible-added")) && (n = !0, window.clearTimeout(r), r = window.setTimeout(function () {
        n = !1;
      }, 100), l(e.target));
    }
    function h(e) {
      "hidden" === document.visibilityState && (n && (t = !0), m());
    }
    function m() {
      document.addEventListener("mousemove", g), document.addEventListener("mousedown", g), document.addEventListener("mouseup", g), document.addEventListener("pointermove", g), document.addEventListener("pointerdown", g), document.addEventListener("pointerup", g), document.addEventListener("touchmove", g), document.addEventListener("touchstart", g), document.addEventListener("touchend", g);
    }
    function p() {
      document.removeEventListener("mousemove", g), document.removeEventListener("mousedown", g), document.removeEventListener("mouseup", g), document.removeEventListener("pointermove", g), document.removeEventListener("pointerdown", g), document.removeEventListener("pointerup", g), document.removeEventListener("touchmove", g), document.removeEventListener("touchstart", g), document.removeEventListener("touchend", g);
    }
    function g(e) {
      e.target.nodeName && "html" === e.target.nodeName.toLowerCase() || (t = !1, p());
    }
    document.addEventListener("keydown", c, !0), document.addEventListener("mousedown", d, !0), document.addEventListener("pointerdown", d, !0), document.addEventListener("touchstart", d, !0), document.addEventListener("visibilitychange", h, !0), m(), e.addEventListener("focus", u, !0), e.addEventListener("blur", f, !0), e.nodeType === Node.DOCUMENT_FRAGMENT_NODE && e.host ? e.host.setAttribute("data-js-focus-visible", "") : e.nodeType === Node.DOCUMENT_NODE && (document.documentElement.classList.add("js-focus-visible"), document.documentElement.setAttribute("data-js-focus-visible", ""));
  }
  if ("undefined" != typeof window && "undefined" != typeof document) {
    var t;
    window.applyFocusVisiblePolyfill = e;
    try {
      t = new CustomEvent("focus-visible-polyfill-ready");
    } catch (e) {
      (t = document.createEvent("CustomEvent")).initCustomEvent("focus-visible-polyfill-ready", !1, !1, {});
    }
    window.dispatchEvent(t);
  }
  "undefined" != typeof document && e(document);
}();
var y,
  b = {
    cardBgColor: "#ffffff",
    cardDetailsBackGround: "#ffffff",
    cardDetailsColor: "#000",
    cardMediaBgColor: "#f5f5f5",
    cardSubtitleColor: "#000",
    cardTitleColor: "#007FFF",
    detailsColor: "#000",
    nestedCardBgColor: "#f5f5f5",
    nestedCardDetailsBackGround: "#f5f5f5",
    nestedCardDetailsColor: "#000",
    nestedCardSubtitleColor: "#000",
    nestedCardTitleColor: "#000",
    primary: "#007FFF",
    secondary: "#ffdf00",
    titleColor: "#007FFF",
    titleColorActive: "#007FFF"
  },
  w = {
    cardBgColor: "#191919",
    cardDetailsBackGround: "#191919",
    cardDetailsColor: "#ffff0f",
    cardMediaBgColor: "#2f2f2f",
    cardSubtitleColor: "#ffffff",
    cardTitleColor: "#007FFF",
    detailsColor: "#ffffff",
    nestedCardBgColor: "#333333",
    nestedCardDetailsBackGround: "#333333",
    nestedCardDetailsColor: "#ffffff",
    nestedCardSubtitleColor: "#ffffff",
    nestedCardTitleColor: "#ffffff",
    primary: "#007FFF",
    secondary: "#ffdf00",
    titleColor: "#007FFF",
    titleColorActive: "#007FFF"
  },
  C = function C(e, t) {
    return "rgba(".concat(parseInt(e.slice(1, 3), 16), ", ").concat(parseInt(e.slice(3, 5), 16), ", ").concat(parseInt(e.slice(5, 7), 16), ", ").concat(t, ")");
  },
  x = function x(e) {
    return "HORIZONTAL" === e || "VERTICAL" === e ? "reveal" : "VERTICAL_ALTERNATING" === e ? "slide_from_sides" : "reveal";
  },
  S = i({}),
  k = function k(t) {
    var n = t.cardHeight;
    void 0 === n && (n = 200);
    var r = t.cardLess;
    void 0 === r && (r = !1);
    var i = t.flipLayout,
      l = t.items;
    void 0 === l && (l = []);
    var c = t.theme,
      d = t.buttonTexts,
      u = t.classNames,
      f = t.mode;
    void 0 === f && (f = "VERTICAL_ALTERNATING");
    var h = t.fontSizes,
      m = t.textOverlay,
      p = t.darkMode,
      g = t.slideShow,
      v = t.onThemeChange,
      y = t.mediaSettings,
      C = t.mediaHeight;
    void 0 === C && (C = 200);
    var k = t.contentDetailsHeight;
    void 0 === k && (k = 10);
    var N = o(p),
      A = N[0],
      T = N[1],
      E = a(function () {
        return Math.max(k || 0 + C || 0, n);
      }, []),
      O = a(function () {
        var e = Math.round(.75 * E);
        return k > E ? Math.min(k, e) : Math.max(k, e);
      }, [E]),
      L = s(function () {
        T(!A), null == v || v();
      }, [A]),
      $ = a(function () {
        return Object.assign({}, {
          borderLessCards: !1,
          cardHeight: E,
          cardLess: !1,
          disableAutoScrollOnClick: !1,
          disableClickOnCircle: !1,
          enableBreakPoint: !0,
          enableDarkToggle: !1,
          focusActiveItemOnLoad: !1,
          lineWidth: 3,
          mediaHeight: 200,
          nestedCardHeight: 150,
          scrollable: {
            scrollbar: !1
          },
          showAllCardsHorizontal: !1,
          showProgressOnSlideshow: g,
          slideItemDuration: 2e3,
          slideShowType: x(f),
          textOverlay: !1,
          timelinePointDimension: 16,
          timelinePointShape: "circle",
          titleDateFormat: "MMM DD, YYYY",
          useReadMore: !0,
          verticalBreakPoint: 1028
        }, Object.assign({}, t, {
          activeItemIndex: i ? (null == l ? void 0 : l.length) - 1 : 0,
          buttonTexts: Object.assign({}, {
            dark: "Switch to Dark Mode",
            first: "Go to First",
            last: "Go to Last",
            light: "Switch to Light Mode",
            next: "Next",
            play: "Play Slideshow",
            previous: "Previous",
            stop: "Stop Slideshow"
          }, d),
          cardHeight: r ? n || 80 : n,
          classNames: Object.assign({}, {
            card: "rc-card",
            cardMedia: "rc-card-media",
            cardSubTitle: "rc-card-subtitle",
            cardText: "rc-card-text",
            cardTitle: "rc-card-title",
            controls: "rc-controls",
            title: "rc-title"
          }, u),
          contentDetailsHeight: O,
          darkMode: A,
          fontSizes: Object.assign({}, {
            cardSubtitle: "0.85rem",
            cardText: "1rem",
            cardTitle: "1rem",
            title: "1rem"
          }, h),
          mediaSettings: Object.assign({}, {
            align: "VERTICAL" !== f || m ? "center" : "left",
            imageFit: "cover"
          }, y),
          theme: Object.assign({}, (e = A, e ? w : b), c),
          toggleDarkMode: L
        }));
        var e;
      }, [O, E, A, L]),
      M = t.children;
    return e(S.Provider, {
      value: Object.assign({}, $, {
        darkMode: A,
        toggleDarkMode: L
      }),
      children: M
    });
  },
  N = {
    exports: {}
  };
y = N, function () {
  var e = {}.hasOwnProperty;
  function t() {
    for (var n = arguments, r = [], i = 0; i < arguments.length; i++) {
      var o = n[i];
      if (o) {
        var a = typeof o;
        if ("string" === a || "number" === a) r.push(o);else if (Array.isArray(o)) {
          if (o.length) {
            var s = t.apply(null, o);
            s && r.push(s);
          }
        } else if ("object" === a) {
          if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]")) {
            r.push(o.toString());
            continue;
          }
          for (var l in o) e.call(o, l) && o[l] && r.push(l);
        }
      }
    }
    return r.join(" ");
  }
  y.exports ? (t.default = t, y.exports = t) : window.classNames = t;
}();
var A,
  T = p(N.exports),
  E = function E(e, t, n) {
    void 0 === n && (n = !0);
    var r = o(!1),
      i = r[0],
      a = r[1];
    return l(function () {
      if (n) {
        var t = window.matchMedia(e);
        t.matches !== i && a(t.matches);
        var r = function r() {
          a(t.matches);
        };
        return t.addEventListener("change", r), function () {
          t.removeEventListener("change", r);
        };
      }
    }, [e, i, n]), l(function () {
      i && (null == t || t());
    }, [i]), i;
  },
  O = function O(e, t) {
    var n = o(0),
      r = n[0],
      i = n[1];
    return [r, a(function () {
      return function (n, r) {
        var o = n.clientWidth,
          a = n.scrollLeft,
          s = n.scrollTop,
          l = n.clientHeight,
          c = r.pointOffset,
          d = r.pointWidth,
          u = r.contentHeight,
          f = r.contentOffset;
        if (c) if ("HORIZONTAL" === e && t && d) {
          var h = a + o,
            m = c + d,
            p = c - a,
            g = h - c;
          c >= a && m <= h || c < a && m > a || m > h && c < h ? (p <= t && p >= 0 || g <= t && g >= 0) && i(c - t) : i(c - t);
        } else if ("VERTICAL" === e || "VERTICAL_ALTERNATING" === e) {
          if (!f || !u) return;
          var v = s + l,
            y = f + u,
            b = f - u,
            w = !(f >= s && y <= v) || f < s && y > s || y > v && f < v;
          w && b + u < v ? i(b + Math.round(u / 2)) : w && i(b);
        }
      };
    }, [e, t])];
  },
  L = function L() {
    return e("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "feather feather-chevron-left",
      children: e("polyline", {
        points: "15 18 9 12 15 6"
      })
    });
  },
  $ = function $() {
    return e("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "feather feather-chevron-right",
      children: e("polyline", {
        points: "9 18 15 12 9 6"
      })
    });
  },
  M = function M() {
    return e("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "feather feather-maximize-2",
      children: e("path", {
        d: "M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"
      })
    });
  },
  I = function I() {
    return e("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: e("path", {
        d: "M4 14h6v6M20 10h-6V4M14 10l7-7M3 21l7-7"
      })
    });
  },
  D = function D() {
    return e("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: e("path", {
        d: "M5 12h14"
      })
    });
  },
  R = function R() {
    return e("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      viewBox: "0 0 24 24",
      children: e("path", {
        d: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
      })
    });
  },
  P = function P() {
    return e("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: e("path", {
        d: "M12 5v14M5 12h14"
      })
    });
  },
  _ = function _() {
    return t("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      viewBox: "0 0 24 24",
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 10
      }), e("path", {
        d: "M9 9h6v6H9z"
      })]
    });
  },
  j = function j() {
    return t("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "feather feather-sun",
      children: [e("circle", {
        cx: 12,
        cy: 12,
        r: 5
      }), e("path", {
        d: "M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"
      })]
    });
  },
  H = function H() {
    return t("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "feather feather-chevrons-left",
      children: [e("polyline", {
        points: "11 17 6 12 11 7"
      }), e("polyline", {
        points: "18 17 13 12 18 7"
      })]
    });
  },
  z = function z() {
    return t("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      className: "feather feather-chevrons-right",
      children: [e("polyline", {
        points: "13 17 18 12 13 7"
      }), e("polyline", {
        points: "6 17 11 12 6 7"
      })]
    });
  },
  F = function F() {
    return e("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: e("polygon", {
        points: "5 3 19 12 5 21 5 3"
      })
    });
  },
  W = {
    exports: {}
  },
  B = {};
var V,
  G = {};
"production" === process.env.NODE_ENV ? W.exports = function () {
  if (A) return B;
  A = 1;
  var e,
    t = Symbol.for("react.element"),
    n = Symbol.for("react.portal"),
    r = Symbol.for("react.fragment"),
    i = Symbol.for("react.strict_mode"),
    o = Symbol.for("react.profiler"),
    a = Symbol.for("react.provider"),
    s = Symbol.for("react.context"),
    l = Symbol.for("react.server_context"),
    c = Symbol.for("react.forward_ref"),
    d = Symbol.for("react.suspense"),
    u = Symbol.for("react.suspense_list"),
    f = Symbol.for("react.memo"),
    h = Symbol.for("react.lazy"),
    m = Symbol.for("react.offscreen");
  function p(e) {
    if ("object" == typeof e && null !== e) {
      var m = e.$$typeof;
      switch (m) {
        case t:
          switch (e = e.type) {
            case r:
            case o:
            case i:
            case d:
            case u:
              return e;
            default:
              switch (e = e && e.$$typeof) {
                case l:
                case s:
                case c:
                case h:
                case f:
                case a:
                  return e;
                default:
                  return m;
              }
          }
        case n:
          return m;
      }
    }
  }
  return e = Symbol.for("react.module.reference"), B.ContextConsumer = s, B.ContextProvider = a, B.Element = t, B.ForwardRef = c, B.Fragment = r, B.Lazy = h, B.Memo = f, B.Portal = n, B.Profiler = o, B.StrictMode = i, B.Suspense = d, B.SuspenseList = u, B.isAsyncMode = function () {
    return !1;
  }, B.isConcurrentMode = function () {
    return !1;
  }, B.isContextConsumer = function (e) {
    return p(e) === s;
  }, B.isContextProvider = function (e) {
    return p(e) === a;
  }, B.isElement = function (e) {
    return "object" == typeof e && null !== e && e.$$typeof === t;
  }, B.isForwardRef = function (e) {
    return p(e) === c;
  }, B.isFragment = function (e) {
    return p(e) === r;
  }, B.isLazy = function (e) {
    return p(e) === h;
  }, B.isMemo = function (e) {
    return p(e) === f;
  }, B.isPortal = function (e) {
    return p(e) === n;
  }, B.isProfiler = function (e) {
    return p(e) === o;
  }, B.isStrictMode = function (e) {
    return p(e) === i;
  }, B.isSuspense = function (e) {
    return p(e) === d;
  }, B.isSuspenseList = function (e) {
    return p(e) === u;
  }, B.isValidElementType = function (t) {
    return "string" == typeof t || "function" == typeof t || t === r || t === o || t === i || t === d || t === u || t === m || "object" == typeof t && null !== t && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === a || t.$$typeof === s || t.$$typeof === c || t.$$typeof === e || void 0 !== t.getModuleId);
  }, B.typeOf = p, B;
}() : W.exports = (V || (V = 1, "production" !== process.env.NODE_ENV && function () {
  var e,
    t = Symbol.for("react.element"),
    n = Symbol.for("react.portal"),
    r = Symbol.for("react.fragment"),
    i = Symbol.for("react.strict_mode"),
    o = Symbol.for("react.profiler"),
    a = Symbol.for("react.provider"),
    s = Symbol.for("react.context"),
    l = Symbol.for("react.server_context"),
    c = Symbol.for("react.forward_ref"),
    d = Symbol.for("react.suspense"),
    u = Symbol.for("react.suspense_list"),
    f = Symbol.for("react.memo"),
    h = Symbol.for("react.lazy"),
    m = Symbol.for("react.offscreen");
  function p(e) {
    if ("object" == typeof e && null !== e) {
      var m = e.$$typeof;
      switch (m) {
        case t:
          var p = e.type;
          switch (p) {
            case r:
            case o:
            case i:
            case d:
            case u:
              return p;
            default:
              var g = p && p.$$typeof;
              switch (g) {
                case l:
                case s:
                case c:
                case h:
                case f:
                case a:
                  return g;
                default:
                  return m;
              }
          }
        case n:
          return m;
      }
    }
  }
  e = Symbol.for("react.module.reference");
  var g = s,
    v = a,
    y = t,
    b = c,
    w = r,
    C = h,
    x = f,
    S = n,
    k = o,
    N = i,
    A = d,
    T = u,
    E = !1,
    O = !1;
  G.ContextConsumer = g, G.ContextProvider = v, G.Element = y, G.ForwardRef = b, G.Fragment = w, G.Lazy = C, G.Memo = x, G.Portal = S, G.Profiler = k, G.StrictMode = N, G.Suspense = A, G.SuspenseList = T, G.isAsyncMode = function (e) {
    return E || (E = !0), !1;
  }, G.isConcurrentMode = function (e) {
    return O || (O = !0), !1;
  }, G.isContextConsumer = function (e) {
    return p(e) === s;
  }, G.isContextProvider = function (e) {
    return p(e) === a;
  }, G.isElement = function (e) {
    return "object" == typeof e && null !== e && e.$$typeof === t;
  }, G.isForwardRef = function (e) {
    return p(e) === c;
  }, G.isFragment = function (e) {
    return p(e) === r;
  }, G.isLazy = function (e) {
    return p(e) === h;
  }, G.isMemo = function (e) {
    return p(e) === f;
  }, G.isPortal = function (e) {
    return p(e) === n;
  }, G.isProfiler = function (e) {
    return p(e) === o;
  }, G.isStrictMode = function (e) {
    return p(e) === i;
  }, G.isSuspense = function (e) {
    return p(e) === d;
  }, G.isSuspenseList = function (e) {
    return p(e) === u;
  }, G.isValidElementType = function (t) {
    return "string" == typeof t || "function" == typeof t || t === r || t === o || t === i || t === d || t === u || t === m || "object" == typeof t && null !== t && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === a || t.$$typeof === s || t.$$typeof === c || t.$$typeof === e || void 0 !== t.getModuleId);
  }, G.typeOf = p;
}()), G);
var Y = W.exports;
function U(e) {
  function t(e, r, l, c, f) {
    for (var h, m, p, g, w, x = 0, S = 0, k = 0, N = 0, A = 0, M = 0, D = p = h = 0, P = 0, _ = 0, j = 0, H = 0, z = l.length, F = z - 1, W = "", B = "", V = "", G = ""; P < z;) {
      if (m = l.charCodeAt(P), P === F && 0 !== S + N + k + x && (0 !== S && (m = 47 === S ? 10 : 47), N = k = x = 0, z++, F++), 0 === S + N + k + x) {
        if (P === F && (0 < _ && (W = W.replace(u, "")), 0 < W.trim().length)) {
          switch (m) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              W += l.charAt(P);
          }
          m = 59;
        }
        switch (m) {
          case 123:
            for (h = (W = W.trim()).charCodeAt(0), p = 1, H = ++P; P < z;) {
              switch (m = l.charCodeAt(P)) {
                case 123:
                  p++;
                  break;
                case 125:
                  p--;
                  break;
                case 47:
                  switch (m = l.charCodeAt(P + 1)) {
                    case 42:
                    case 47:
                      e: {
                        for (D = P + 1; D < F; ++D) switch (l.charCodeAt(D)) {
                          case 47:
                            if (42 === m && 42 === l.charCodeAt(D - 1) && P + 2 !== D) {
                              P = D + 1;
                              break e;
                            }
                            break;
                          case 10:
                            if (47 === m) {
                              P = D + 1;
                              break e;
                            }
                        }
                        P = D;
                      }
                  }
                  break;
                case 91:
                  m++;
                case 40:
                  m++;
                case 34:
                case 39:
                  for (; P++ < F && l.charCodeAt(P) !== m;);
              }
              if (0 === p) break;
              P++;
            }
            if (p = l.substring(H, P), 0 === h && (h = (W = W.replace(d, "").trim()).charCodeAt(0)), 64 === h) {
              switch (0 < _ && (W = W.replace(u, "")), m = W.charCodeAt(1)) {
                case 100:
                case 109:
                case 115:
                case 45:
                  _ = r;
                  break;
                default:
                  _ = $;
              }
              if (H = (p = t(r, _, p, m, f + 1)).length, 0 < I && (w = s(3, p, _ = n($, W, j), r, E, T, H, m, f, c), W = _.join(""), void 0 !== w && 0 === (H = (p = w.trim()).length) && (m = 0, p = "")), 0 < H) switch (m) {
                case 115:
                  W = W.replace(C, a);
                case 100:
                case 109:
                case 45:
                  p = W + "{" + p + "}";
                  break;
                case 107:
                  p = (W = W.replace(v, "$1 $2")) + "{" + p + "}", p = 1 === L || 2 === L && o("@" + p, 3) ? "@-webkit-" + p + "@" + p : "@" + p;
                  break;
                default:
                  p = W + p, 112 === c && (B += p, p = "");
              } else p = "";
            } else p = t(r, n(r, W, j), p, c, f + 1);
            V += p, p = j = _ = D = h = 0, W = "", m = l.charCodeAt(++P);
            break;
          case 125:
          case 59:
            if (1 < (H = (W = (0 < _ ? W.replace(u, "") : W).trim()).length)) switch (0 === D && (45 === (h = W.charCodeAt(0)) || 96 < h && 123 > h) && (H = (W = W.replace(" ", ":")).length), 0 < I && void 0 !== (w = s(1, W, r, e, E, T, B.length, c, f, c)) && 0 === (H = (W = w.trim()).length) && (W = "\0\0"), h = W.charCodeAt(0), m = W.charCodeAt(1), h) {
              case 0:
                break;
              case 64:
                if (105 === m || 99 === m) {
                  G += W + l.charAt(P);
                  break;
                }
              default:
                58 !== W.charCodeAt(H - 1) && (B += i(W, h, m, W.charCodeAt(2)));
            }
            j = _ = D = h = 0, W = "", m = l.charCodeAt(++P);
        }
      }
      switch (m) {
        case 13:
        case 10:
          47 === S ? S = 0 : 0 === 1 + h && 107 !== c && 0 < W.length && (_ = 1, W += "\0"), 0 < I * R && s(0, W, r, e, E, T, B.length, c, f, c), T = 1, E++;
          break;
        case 59:
        case 125:
          if (0 === S + N + k + x) {
            T++;
            break;
          }
        default:
          switch (T++, g = l.charAt(P), m) {
            case 9:
            case 32:
              if (0 === N + x + S) switch (A) {
                case 44:
                case 58:
                case 9:
                case 32:
                  g = "";
                  break;
                default:
                  32 !== m && (g = " ");
              }
              break;
            case 0:
              g = "\\0";
              break;
            case 12:
              g = "\\f";
              break;
            case 11:
              g = "\\v";
              break;
            case 38:
              0 === N + S + x && (_ = j = 1, g = "\f" + g);
              break;
            case 108:
              if (0 === N + S + x + O && 0 < D) switch (P - D) {
                case 2:
                  112 === A && 58 === l.charCodeAt(P - 3) && (O = A);
                case 8:
                  111 === M && (O = M);
              }
              break;
            case 58:
              0 === N + S + x && (D = P);
              break;
            case 44:
              0 === S + k + N + x && (_ = 1, g += "\r");
              break;
            case 34:
            case 39:
              0 === S && (N = N === m ? 0 : 0 === N ? m : N);
              break;
            case 91:
              0 === N + S + k && x++;
              break;
            case 93:
              0 === N + S + k && x--;
              break;
            case 41:
              0 === N + S + x && k--;
              break;
            case 40:
              if (0 === N + S + x) {
                if (0 === h) if (2 * A + 3 * M == 533) ;else h = 1;
                k++;
              }
              break;
            case 64:
              0 === S + k + N + x + D + p && (p = 1);
              break;
            case 42:
            case 47:
              if (!(0 < N + x + k)) switch (S) {
                case 0:
                  switch (2 * m + 3 * l.charCodeAt(P + 1)) {
                    case 235:
                      S = 47;
                      break;
                    case 220:
                      H = P, S = 42;
                  }
                  break;
                case 42:
                  47 === m && 42 === A && H + 2 !== P && (33 === l.charCodeAt(H + 2) && (B += l.substring(H, P + 1)), g = "", S = 0);
              }
          }
          0 === S && (W += g);
      }
      M = A, A = m, P++;
    }
    if (0 < (H = B.length)) {
      if (_ = r, 0 < I && void 0 !== (w = s(2, B, _, e, E, T, H, c, f, c)) && 0 === (B = w).length) return G + B + V;
      if (B = _.join(",") + "{" + B + "}", 0 != L * O) {
        switch (2 !== L || o(B, 2) || (O = 0), O) {
          case 111:
            B = B.replace(b, ":-moz-$1") + B;
            break;
          case 112:
            B = B.replace(y, "::-webkit-input-$1") + B.replace(y, "::-moz-$1") + B.replace(y, ":-ms-input-$1") + B;
        }
        O = 0;
      }
    }
    return G + B + V;
  }
  function n(e, t, n) {
    var i = t.trim().split(p);
    t = i;
    var o = i.length,
      a = e.length;
    switch (a) {
      case 0:
      case 1:
        var s = 0;
        for (e = 0 === a ? "" : e[0] + " "; s < o; ++s) t[s] = r(e, t[s], n).trim();
        break;
      default:
        var l = s = 0;
        for (t = []; s < o; ++s) for (var c = 0; c < a; ++c) t[l++] = r(e[c] + " ", i[s], n).trim();
    }
    return t;
  }
  function r(e, t, n) {
    var r = t.charCodeAt(0);
    switch (33 > r && (r = (t = t.trim()).charCodeAt(0)), r) {
      case 38:
        return t.replace(g, "$1" + e.trim());
      case 58:
        return e.trim() + t.replace(g, "$1" + e.trim());
      default:
        if (0 < 1 * n && 0 < t.indexOf("\f")) return t.replace(g, (58 === e.charCodeAt(0) ? "" : "$1") + e.trim());
    }
    return e + t;
  }
  function i(e, t, n, r) {
    var a = e + ";",
      s = 2 * t + 3 * n + 4 * r;
    if (944 === s) {
      e = a.indexOf(":", 9) + 1;
      var l = a.substring(e, a.length - 1).trim();
      return l = a.substring(0, e).trim() + l + ";", 1 === L || 2 === L && o(l, 1) ? "-webkit-" + l + l : l;
    }
    if (0 === L || 2 === L && !o(a, 1)) return a;
    switch (s) {
      case 1015:
        return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
      case 951:
        return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
      case 963:
        return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
      case 1009:
        if (100 !== a.charCodeAt(4)) break;
      case 969:
      case 942:
        return "-webkit-" + a + a;
      case 978:
        return "-webkit-" + a + "-moz-" + a + a;
      case 1019:
      case 983:
        return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
      case 883:
        if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
        if (0 < a.indexOf("image-set(", 11)) return a.replace(A, "$1-webkit-$2") + a;
        break;
      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
          case 115:
            return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
          case 98:
            return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
        }
        return "-webkit-" + a + "-ms-" + a + a;
      case 964:
        return "-webkit-" + a + "-ms-flex-" + a + a;
      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        return "-webkit-box-pack" + (l = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify")) + "-webkit-" + a + "-ms-flex-pack" + l + a;
      case 1005:
        return h.test(a) ? a.replace(f, ":-webkit-") + a.replace(f, ":-moz-") + a : a;
      case 1e3:
        switch (t = (l = a.substring(13).trim()).indexOf("-") + 1, l.charCodeAt(0) + l.charCodeAt(t)) {
          case 226:
            l = a.replace(w, "tb");
            break;
          case 232:
            l = a.replace(w, "tb-rl");
            break;
          case 220:
            l = a.replace(w, "lr");
            break;
          default:
            return a;
        }
        return "-webkit-" + a + "-ms-" + l + a;
      case 1017:
        if (-1 === a.indexOf("sticky", 9)) break;
      case 975:
        switch (t = (a = e).length - 10, s = (l = (33 === a.charCodeAt(t) ? a.substring(0, t) : a).substring(e.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | l.charCodeAt(7))) {
          case 203:
            if (111 > l.charCodeAt(8)) break;
          case 115:
            a = a.replace(l, "-webkit-" + l) + ";" + a;
            break;
          case 207:
          case 102:
            a = a.replace(l, "-webkit-" + (102 < s ? "inline-" : "") + "box") + ";" + a.replace(l, "-webkit-" + l) + ";" + a.replace(l, "-ms-" + l + "box") + ";" + a;
        }
        return a + ";";
      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return l = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + l + "-ms-flex-" + l + a;
          case 115:
            return "-webkit-" + a + "-ms-flex-item-" + a.replace(S, "") + a;
          default:
            return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(S, "") + a;
        }
        break;
      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
      case 931:
      case 953:
        if (!0 === N.test(e)) return 115 === (l = e.substring(e.indexOf(":") + 1)).charCodeAt(0) ? i(e.replace("stretch", "fill-available"), t, n, r).replace(":fill-available", ":stretch") : a.replace(l, "-webkit-" + l) + a.replace(l, "-moz-" + l.replace("fill-", "")) + a;
        break;
      case 962:
        if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === n + r && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(m, "$1-webkit-$2") + a;
    }
    return a;
  }
  function o(e, t) {
    var n = e.indexOf(1 === t ? ":" : "{"),
      r = e.substring(0, 3 !== t ? n : 10);
    return n = e.substring(n + 1, e.length - 1), D(2 !== t ? r : r.replace(k, "$1"), n, t);
  }
  function a(e, t) {
    var n = i(t, t.charCodeAt(0), t.charCodeAt(1), t.charCodeAt(2));
    return n !== t + ";" ? n.replace(x, " or ($1)").substring(4) : "(" + t + ")";
  }
  function s(e, t, n, r, i, o, a, s, l, d) {
    for (var u, f = 0, h = t; f < I; ++f) switch (u = M[f].call(c, e, h, n, r, i, o, a, s, l, d)) {
      case void 0:
      case !1:
      case !0:
      case null:
        break;
      default:
        h = u;
    }
    if (h !== t) return h;
  }
  function l(e) {
    return void 0 !== (e = e.prefix) && (D = null, e ? "function" != typeof e ? L = 1 : (L = 2, D = e) : L = 0), l;
  }
  function c(e, n) {
    var r = e;
    if (33 > r.charCodeAt(0) && (r = r.trim()), r = [r], 0 < I) {
      var i = s(-1, n, r, r, E, T, 0, 0, 0, 0);
      void 0 !== i && "string" == typeof i && (n = i);
    }
    var o = t($, r, n, 0, 0);
    return 0 < I && void 0 !== (i = s(-2, o, r, r, E, T, o.length, 0, 0, 0)) && (o = i), "", O = 0, T = E = 1, o;
  }
  var d = /^\0+/g,
    u = /[\0\r\f]/g,
    f = /: */g,
    h = /zoo|gra/,
    m = /([,: ])(transform)/g,
    p = /,\r+?/g,
    g = /([\t\r\n ])*\f?&/g,
    v = /@(k\w+)\s*(\S*)\s*/,
    y = /::(place)/g,
    b = /:(read-only)/g,
    w = /[svh]\w+-[tblr]{2}/,
    C = /\(\s*(.*)\s*\)/g,
    x = /([\s\S]*?);/g,
    S = /-self|flex-/g,
    k = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
    N = /stretch|:\s*\w+\-(?:conte|avail)/,
    A = /([^-])(image-set\()/,
    T = 1,
    E = 1,
    O = 0,
    L = 1,
    $ = [],
    M = [],
    I = 0,
    D = null,
    R = 0;
  return c.use = function e(t) {
    switch (t) {
      case void 0:
      case null:
        I = M.length = 0;
        break;
      default:
        if ("function" == typeof t) M[I++] = t;else if ("object" == typeof t) for (var n = 0, r = t.length; n < r; ++n) e(t[n]);else R = 0 | !!t;
    }
    return e;
  }, c.set = l, void 0 !== e && l(e), c;
}
var Z = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function q(e) {
  var t = Object.create(null);
  return function (n) {
    return void 0 === t[n] && (t[n] = e(n)), t[n];
  };
}
var X,
  J = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/,
  K = q(function (e) {
    return J.test(e) || 111 === e.charCodeAt(0) && 110 === e.charCodeAt(1) && e.charCodeAt(2) < 91;
  }),
  Q = {
    exports: {}
  },
  ee = {};
var te,
  ne = {};
"production" === process.env.NODE_ENV ? Q.exports = function () {
  if (X) return ee;
  X = 1;
  var e = "function" == typeof Symbol && Symbol.for,
    t = e ? Symbol.for("react.element") : 60103,
    n = e ? Symbol.for("react.portal") : 60106,
    r = e ? Symbol.for("react.fragment") : 60107,
    i = e ? Symbol.for("react.strict_mode") : 60108,
    o = e ? Symbol.for("react.profiler") : 60114,
    a = e ? Symbol.for("react.provider") : 60109,
    s = e ? Symbol.for("react.context") : 60110,
    l = e ? Symbol.for("react.async_mode") : 60111,
    c = e ? Symbol.for("react.concurrent_mode") : 60111,
    d = e ? Symbol.for("react.forward_ref") : 60112,
    u = e ? Symbol.for("react.suspense") : 60113,
    f = e ? Symbol.for("react.suspense_list") : 60120,
    h = e ? Symbol.for("react.memo") : 60115,
    m = e ? Symbol.for("react.lazy") : 60116,
    p = e ? Symbol.for("react.block") : 60121,
    g = e ? Symbol.for("react.fundamental") : 60117,
    v = e ? Symbol.for("react.responder") : 60118,
    y = e ? Symbol.for("react.scope") : 60119;
  function b(e) {
    if ("object" == typeof e && null !== e) {
      var f = e.$$typeof;
      switch (f) {
        case t:
          switch (e = e.type) {
            case l:
            case c:
            case r:
            case o:
            case i:
            case u:
              return e;
            default:
              switch (e = e && e.$$typeof) {
                case s:
                case d:
                case m:
                case h:
                case a:
                  return e;
                default:
                  return f;
              }
          }
        case n:
          return f;
      }
    }
  }
  function w(e) {
    return b(e) === c;
  }
  return ee.AsyncMode = l, ee.ConcurrentMode = c, ee.ContextConsumer = s, ee.ContextProvider = a, ee.Element = t, ee.ForwardRef = d, ee.Fragment = r, ee.Lazy = m, ee.Memo = h, ee.Portal = n, ee.Profiler = o, ee.StrictMode = i, ee.Suspense = u, ee.isAsyncMode = function (e) {
    return w(e) || b(e) === l;
  }, ee.isConcurrentMode = w, ee.isContextConsumer = function (e) {
    return b(e) === s;
  }, ee.isContextProvider = function (e) {
    return b(e) === a;
  }, ee.isElement = function (e) {
    return "object" == typeof e && null !== e && e.$$typeof === t;
  }, ee.isForwardRef = function (e) {
    return b(e) === d;
  }, ee.isFragment = function (e) {
    return b(e) === r;
  }, ee.isLazy = function (e) {
    return b(e) === m;
  }, ee.isMemo = function (e) {
    return b(e) === h;
  }, ee.isPortal = function (e) {
    return b(e) === n;
  }, ee.isProfiler = function (e) {
    return b(e) === o;
  }, ee.isStrictMode = function (e) {
    return b(e) === i;
  }, ee.isSuspense = function (e) {
    return b(e) === u;
  }, ee.isValidElementType = function (e) {
    return "string" == typeof e || "function" == typeof e || e === r || e === c || e === o || e === i || e === u || e === f || "object" == typeof e && null !== e && (e.$$typeof === m || e.$$typeof === h || e.$$typeof === a || e.$$typeof === s || e.$$typeof === d || e.$$typeof === g || e.$$typeof === v || e.$$typeof === y || e.$$typeof === p);
  }, ee.typeOf = b, ee;
}() : Q.exports = (te || (te = 1, "production" !== process.env.NODE_ENV && function () {
  var e = "function" == typeof Symbol && Symbol.for,
    t = e ? Symbol.for("react.element") : 60103,
    n = e ? Symbol.for("react.portal") : 60106,
    r = e ? Symbol.for("react.fragment") : 60107,
    i = e ? Symbol.for("react.strict_mode") : 60108,
    o = e ? Symbol.for("react.profiler") : 60114,
    a = e ? Symbol.for("react.provider") : 60109,
    s = e ? Symbol.for("react.context") : 60110,
    l = e ? Symbol.for("react.async_mode") : 60111,
    c = e ? Symbol.for("react.concurrent_mode") : 60111,
    d = e ? Symbol.for("react.forward_ref") : 60112,
    u = e ? Symbol.for("react.suspense") : 60113,
    f = e ? Symbol.for("react.suspense_list") : 60120,
    h = e ? Symbol.for("react.memo") : 60115,
    m = e ? Symbol.for("react.lazy") : 60116,
    p = e ? Symbol.for("react.block") : 60121,
    g = e ? Symbol.for("react.fundamental") : 60117,
    v = e ? Symbol.for("react.responder") : 60118,
    y = e ? Symbol.for("react.scope") : 60119;
  function b(e) {
    if ("object" == typeof e && null !== e) {
      var f = e.$$typeof;
      switch (f) {
        case t:
          var p = e.type;
          switch (p) {
            case l:
            case c:
            case r:
            case o:
            case i:
            case u:
              return p;
            default:
              var g = p && p.$$typeof;
              switch (g) {
                case s:
                case d:
                case m:
                case h:
                case a:
                  return g;
                default:
                  return f;
              }
          }
        case n:
          return f;
      }
    }
  }
  var w = l,
    C = c,
    x = s,
    S = a,
    k = t,
    N = d,
    A = r,
    T = m,
    E = h,
    O = n,
    L = o,
    $ = i,
    M = u,
    I = !1;
  function D(e) {
    return b(e) === c;
  }
  ne.AsyncMode = w, ne.ConcurrentMode = C, ne.ContextConsumer = x, ne.ContextProvider = S, ne.Element = k, ne.ForwardRef = N, ne.Fragment = A, ne.Lazy = T, ne.Memo = E, ne.Portal = O, ne.Profiler = L, ne.StrictMode = $, ne.Suspense = M, ne.isAsyncMode = function (e) {
    return I || (I = !0), D(e) || b(e) === l;
  }, ne.isConcurrentMode = D, ne.isContextConsumer = function (e) {
    return b(e) === s;
  }, ne.isContextProvider = function (e) {
    return b(e) === a;
  }, ne.isElement = function (e) {
    return "object" == typeof e && null !== e && e.$$typeof === t;
  }, ne.isForwardRef = function (e) {
    return b(e) === d;
  }, ne.isFragment = function (e) {
    return b(e) === r;
  }, ne.isLazy = function (e) {
    return b(e) === m;
  }, ne.isMemo = function (e) {
    return b(e) === h;
  }, ne.isPortal = function (e) {
    return b(e) === n;
  }, ne.isProfiler = function (e) {
    return b(e) === o;
  }, ne.isStrictMode = function (e) {
    return b(e) === i;
  }, ne.isSuspense = function (e) {
    return b(e) === u;
  }, ne.isValidElementType = function (e) {
    return "string" == typeof e || "function" == typeof e || e === r || e === c || e === o || e === i || e === u || e === f || "object" == typeof e && null !== e && (e.$$typeof === m || e.$$typeof === h || e.$$typeof === a || e.$$typeof === s || e.$$typeof === d || e.$$typeof === g || e.$$typeof === v || e.$$typeof === y || e.$$typeof === p);
  }, ne.typeOf = b;
}()), ne);
var re = Q.exports,
  ie = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  },
  oe = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  },
  ae = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  },
  se = {};
function le(e) {
  return re.isMemo(e) ? ae : se[e.$$typeof] || ie;
}
se[re.ForwardRef] = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, se[re.Memo] = ae;
var ce = Object.defineProperty,
  de = Object.getOwnPropertyNames,
  ue = Object.getOwnPropertySymbols,
  fe = Object.getOwnPropertyDescriptor,
  he = Object.getPrototypeOf,
  me = Object.prototype;
var pe = function e(t, n, r) {
    if ("string" != typeof n) {
      if (me) {
        var i = he(n);
        i && i !== me && e(t, i, r);
      }
      var o = de(n);
      ue && (o = o.concat(ue(n)));
      for (var a = le(t), s = le(n), l = 0; l < o.length; ++l) {
        var c = o[l];
        if (!(oe[c] || r && r[c] || s && s[c] || a && a[c])) {
          var d = fe(n, c);
          try {
            ce(t, c, d);
          } catch (e) {}
        }
      }
    }
    return t;
  },
  ge = p(pe);
function ve() {
  return (ve = Object.assign || function (e) {
    for (var t = arguments, n = 1; n < arguments.length; n++) {
      var r = t[n];
      for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (e[i] = r[i]);
    }
    return e;
  }).apply(this, arguments);
}
var ye = function ye(e, t) {
    for (var n = [e[0]], r = 0, i = t.length; r < i; r += 1) n.push(t[r], e[r + 1]);
    return n;
  },
  be = function be(e) {
    return null !== e && "object" == typeof e && "[object Object]" === (e.toString ? e.toString() : Object.prototype.toString.call(e)) && !Y.typeOf(e);
  },
  we = Object.freeze([]),
  Ce = Object.freeze({});
function xe(e) {
  return "function" == typeof e;
}
function Se(e) {
  return "production" !== process.env.NODE_ENV && "string" == typeof e && e || e.displayName || e.name || "Component";
}
function ke(e) {
  return e && "string" == typeof e.styledComponentId;
}
var Ne = "undefined" != typeof process && void 0 !== process.env && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled",
  Ae = "undefined" != typeof window && "HTMLElement" in window,
  Te = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof process && void 0 !== process.env && (void 0 !== process.env.REACT_APP_SC_DISABLE_SPEEDY && "" !== process.env.REACT_APP_SC_DISABLE_SPEEDY ? "false" !== process.env.REACT_APP_SC_DISABLE_SPEEDY && process.env.REACT_APP_SC_DISABLE_SPEEDY : void 0 !== process.env.SC_DISABLE_SPEEDY && "" !== process.env.SC_DISABLE_SPEEDY ? "false" !== process.env.SC_DISABLE_SPEEDY && process.env.SC_DISABLE_SPEEDY : "production" !== process.env.NODE_ENV)),
  Ee = "production" !== process.env.NODE_ENV ? {
    1: "Cannot create styled-component for component: %s.\n\n",
    2: "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
    3: "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
    4: "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
    5: "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
    6: "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
    7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',
    8: 'ThemeProvider: Please make your "theme" prop an object.\n\n',
    9: "Missing document `<head>`\n\n",
    10: "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
    11: "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
    12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
    13: "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",
    14: 'ThemeProvider: "theme" prop is required.\n\n',
    15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",
    16: "Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",
    17: "CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n"
  } : {};
function Oe() {
  for (var e = arguments, t = arguments.length <= 0 ? void 0 : arguments[0], n = [], r = 1, i = arguments.length; r < i; r += 1) n.push(r < 0 || e.length <= r ? void 0 : e[r]);
  return n.forEach(function (e) {
    t = t.replace(/%[a-z]/, e);
  }), t;
}
function Le(e) {
  for (var t = arguments, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) r[i - 1] = t[i];
  throw "production" === process.env.NODE_ENV ? new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (r.length > 0 ? " Args: " + r.join(", ") : "")) : new Error(Oe.apply(void 0, [Ee[e]].concat(r)).trim());
}
var $e = function () {
    function e(e) {
      this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function (e) {
      for (var t = 0, n = 0; n < e; n++) t += this.groupSizes[n];
      return t;
    }, t.insertRules = function (e, t) {
      if (e >= this.groupSizes.length) {
        for (var n = this.groupSizes, r = n.length, i = r; e >= i;) (i <<= 1) < 0 && Le(16, "" + e);
        this.groupSizes = new Uint32Array(i), this.groupSizes.set(n), this.length = i;
        for (var o = r; o < i; o++) this.groupSizes[o] = 0;
      }
      for (var a = this.indexOfGroup(e + 1), s = 0, l = t.length; s < l; s++) this.tag.insertRule(a, t[s]) && (this.groupSizes[e]++, a++);
    }, t.clearGroup = function (e) {
      if (e < this.length) {
        var t = this.groupSizes[e],
          n = this.indexOfGroup(e),
          r = n + t;
        this.groupSizes[e] = 0;
        for (var i = n; i < r; i++) this.tag.deleteRule(n);
      }
    }, t.getGroup = function (e) {
      var t = "";
      if (e >= this.length || 0 === this.groupSizes[e]) return t;
      for (var n = this.groupSizes[e], r = this.indexOfGroup(e), i = r + n, o = r; o < i; o++) t += this.tag.getRule(o) + "/*!sc*/\n";
      return t;
    }, e;
  }(),
  Me = new Map(),
  Ie = new Map(),
  De = 1,
  Re = function Re(e) {
    if (Me.has(e)) return Me.get(e);
    for (; Ie.has(De);) De++;
    var t = De++;
    return "production" !== process.env.NODE_ENV && ((0 | t) < 0 || t > 1 << 30) && Le(16, "" + t), Me.set(e, t), Ie.set(t, e), t;
  },
  Pe = function Pe(e) {
    return Ie.get(e);
  },
  _e = function _e(e, t) {
    t >= De && (De = t + 1), Me.set(e, t), Ie.set(t, e);
  },
  je = "style[" + Ne + '][data-styled-version="5.3.9"]',
  He = new RegExp("^" + Ne + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),
  ze = function ze(e, t, n) {
    for (var r, i = n.split(","), o = 0, a = i.length; o < a; o++) (r = i[o]) && e.registerName(t, r);
  },
  Fe = function Fe(e, t) {
    for (var n = (t.textContent || "").split("/*!sc*/\n"), r = [], i = 0, o = n.length; i < o; i++) {
      var a = n[i].trim();
      if (a) {
        var s = a.match(He);
        if (s) {
          var l = 0 | parseInt(s[1], 10),
            c = s[2];
          0 !== l && (_e(c, l), ze(e, c, s[3]), e.getTag().insertRules(l, r)), r.length = 0;
        } else r.push(a);
      }
    }
  },
  We = function We(e) {
    var t = document.head,
      n = e || t,
      r = document.createElement("style"),
      i = function (e) {
        for (var t = e.childNodes, n = t.length; n >= 0; n--) {
          var r = t[n];
          if (r && 1 === r.nodeType && r.hasAttribute(Ne)) return r;
        }
      }(n),
      o = void 0 !== i ? i.nextSibling : null;
    r.setAttribute(Ne, "active"), r.setAttribute("data-styled-version", "5.3.9");
    var a = "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
    return a && r.setAttribute("nonce", a), n.insertBefore(r, o), r;
  },
  Be = function () {
    function e(e) {
      var t = this.element = We(e);
      t.appendChild(document.createTextNode("")), this.sheet = function (e) {
        if (e.sheet) return e.sheet;
        for (var t = document.styleSheets, n = 0, r = t.length; n < r; n++) {
          var i = t[n];
          if (i.ownerNode === e) return i;
        }
        Le(17);
      }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function (e, t) {
      try {
        return this.sheet.insertRule(t, e), this.length++, !0;
      } catch (e) {
        return !1;
      }
    }, t.deleteRule = function (e) {
      this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function (e) {
      var t = this.sheet.cssRules[e];
      return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
  }(),
  Ve = function () {
    function e(e) {
      var t = this.element = We(e);
      this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function (e, t) {
      if (e <= this.length && e >= 0) {
        var n = document.createTextNode(t),
          r = this.nodes[e];
        return this.element.insertBefore(n, r || null), this.length++, !0;
      }
      return !1;
    }, t.deleteRule = function (e) {
      this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function (e) {
      return e < this.length ? this.nodes[e].textContent : "";
    }, e;
  }(),
  Ge = function () {
    function e(e) {
      this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function (e, t) {
      return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function (e) {
      this.rules.splice(e, 1), this.length--;
    }, t.getRule = function (e) {
      return e < this.length ? this.rules[e] : "";
    }, e;
  }(),
  Ye = Ae,
  Ue = {
    isServer: !Ae,
    useCSSOMInjection: !Te
  },
  Ze = function () {
    function e(e, t, n) {
      void 0 === e && (e = Ce), void 0 === t && (t = {}), this.options = ve({}, Ue, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && Ae && Ye && (Ye = !1, function (e) {
        for (var t = document.querySelectorAll(je), n = 0, r = t.length; n < r; n++) {
          var i = t[n];
          i && "active" !== i.getAttribute(Ne) && (Fe(e, i), i.parentNode && i.parentNode.removeChild(i));
        }
      }(this));
    }
    e.registerId = function (e) {
      return Re(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function (t, n) {
      return void 0 === n && (n = !0), new e(ve({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function (e) {
      return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function () {
      return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, i = t.target, e = n ? new Ge(i) : r ? new Be(i) : new Ve(i), new $e(e)));
      var e, t, n, r, i;
    }, t.hasNameForId = function (e, t) {
      return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function (e, t) {
      if (Re(e), this.names.has(e)) this.names.get(e).add(t);else {
        var n = new Set();
        n.add(t), this.names.set(e, n);
      }
    }, t.insertRules = function (e, t, n) {
      this.registerName(e, t), this.getTag().insertRules(Re(e), n);
    }, t.clearNames = function (e) {
      this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function (e) {
      this.getTag().clearGroup(Re(e)), this.clearNames(e);
    }, t.clearTag = function () {
      this.tag = void 0;
    }, t.toString = function () {
      return function (e) {
        for (var t = e.getTag(), n = t.length, r = "", i = 0; i < n; i++) {
          var o = Pe(i);
          if (void 0 !== o) {
            var a = e.names.get(o),
              s = t.getGroup(i);
            if (a && s && a.size) {
              var l = Ne + ".g" + i + '[id="' + o + '"]',
                c = "";
              void 0 !== a && a.forEach(function (e) {
                e.length > 0 && (c += e + ",");
              }), r += "" + s + l + '{content:"' + c + '"}/*!sc*/\n';
            }
          }
        }
        return r;
      }(this);
    }, e;
  }(),
  qe = /(a)(d)/gi,
  Xe = function Xe(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
  };
function Je(e) {
  var t,
    n = "";
  for (t = Math.abs(e); t > 52; t = t / 52 | 0) n = Xe(t % 52) + n;
  return (Xe(t % 52) + n).replace(qe, "$1-$2");
}
var Ke = function Ke(e, t) {
    for (var n = t.length; n;) e = 33 * e ^ t.charCodeAt(--n);
    return e;
  },
  Qe = function Qe(e) {
    return Ke(5381, e);
  };
var et = Qe("5.3.9"),
  tt = function () {
    function e(e, t, n) {
      this.rules = e, this.staticRulesId = "", this.isStatic = "production" === process.env.NODE_ENV && (void 0 === n || n.isStatic) && function (e) {
        for (var t = 0; t < e.length; t += 1) {
          var n = e[t];
          if (xe(n) && !ke(n)) return !1;
        }
        return !0;
      }(e), this.componentId = t, this.baseHash = Ke(et, t), this.baseStyle = n, Ze.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function (e, t, n) {
      var r = this.componentId,
        i = [];
      if (this.baseStyle && i.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
        if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) i.push(this.staticRulesId);else {
          var o = pt(this.rules, e, t, n).join(""),
            a = Je(Ke(this.baseHash, o) >>> 0);
          if (!t.hasNameForId(r, a)) {
            var s = n(o, "." + a, void 0, r);
            t.insertRules(r, a, s);
          }
          i.push(a), this.staticRulesId = a;
        }
      } else {
        for (var l = this.rules.length, c = Ke(this.baseHash, n.hash), d = "", u = 0; u < l; u++) {
          var f = this.rules[u];
          if ("string" == typeof f) d += f, "production" !== process.env.NODE_ENV && (c = Ke(c, f + u));else if (f) {
            var h = pt(f, e, t, n),
              m = Array.isArray(h) ? h.join("") : h;
            c = Ke(c, m + u), d += m;
          }
        }
        if (d) {
          var p = Je(c >>> 0);
          if (!t.hasNameForId(r, p)) {
            var g = n(d, "." + p, void 0, r);
            t.insertRules(r, p, g);
          }
          i.push(p);
        }
      }
      return i.join(" ");
    }, e;
  }(),
  nt = /^\s*\/\/.*$/gm,
  rt = [":", "[", ".", "#"];
var it = r.createContext();
it.Consumer;
var ot = r.createContext(),
  at = (ot.Consumer, new Ze()),
  st = function (e) {
    var t,
      n,
      r,
      i,
      o = void 0 === e ? Ce : e,
      a = o.options,
      s = void 0 === a ? Ce : a,
      l = o.plugins,
      c = void 0 === l ? we : l,
      d = new U(s),
      u = [],
      f = function (e) {
        function t(t) {
          if (t) try {
            e(t + "}");
          } catch (e) {}
        }
        return function (n, r, i, o, a, s, l, c, d, u) {
          switch (n) {
            case 1:
              if (0 === d && 64 === r.charCodeAt(0)) return e(r + ";"), "";
              break;
            case 2:
              if (0 === c) return r + "/*|*/";
              break;
            case 3:
              switch (c) {
                case 102:
                case 112:
                  return e(i[0] + r), "";
                default:
                  return r + (0 === u ? "/*|*/" : "");
              }
            case -2:
              r.split("/*|*/}").forEach(t);
          }
        };
      }(function (e) {
        u.push(e);
      }),
      h = function h(e, r, o) {
        return 0 === r && -1 !== rt.indexOf(o[n.length]) || o.match(i) ? e : "." + t;
      };
    function m(e, o, a, s) {
      void 0 === s && (s = "&");
      var l = e.replace(nt, ""),
        c = o && a ? a + " " + o + " { " + l + " }" : l;
      return t = s, n = o, r = new RegExp("\\" + n + "\\b", "g"), i = new RegExp("(\\" + n + "\\b){2,}"), d(a || !o ? "" : o, c);
    }
    return d.use([].concat(c, [function (e, t, i) {
      2 === e && i.length && i[0].lastIndexOf(n) > 0 && (i[0] = i[0].replace(r, h));
    }, f, function (e) {
      if (-2 === e) {
        var t = u;
        return u = [], t;
      }
    }])), m.hash = c.length ? c.reduce(function (e, t) {
      return t.name || Le(15), Ke(e, t.name);
    }, 5381).toString() : "", m;
  }();
var lt = function () {
    function e(e, t) {
      var n = this;
      this.inject = function (e, t) {
        void 0 === t && (t = st);
        var r = n.name + t.hash;
        e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
      }, this.toString = function () {
        return Le(12, String(n.name));
      }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function (e) {
      return void 0 === e && (e = st), this.name + e.hash;
    }, e;
  }(),
  ct = /([A-Z])/,
  dt = /([A-Z])/g,
  ut = /^ms-/,
  ft = function ft(e) {
    return "-" + e.toLowerCase();
  };
function ht(e) {
  return ct.test(e) ? e.replace(dt, ft).replace(ut, "-ms-") : e;
}
var mt = function mt(e) {
  return null == e || !1 === e || "" === e;
};
function pt(e, t, n, r) {
  if (Array.isArray(e)) {
    for (var i, o = [], a = 0, s = e.length; a < s; a += 1) "" !== (i = pt(e[a], t, n, r)) && (Array.isArray(i) ? o.push.apply(o, i) : o.push(i));
    return o;
  }
  if (mt(e)) return "";
  if (ke(e)) return "." + e.styledComponentId;
  if (xe(e)) {
    if ("function" != typeof (c = e) || c.prototype && c.prototype.isReactComponent || !t) return e;
    var l = e(t);
    return "production" !== process.env.NODE_ENV && Y.isElement(l), pt(l, t, n, r);
  }
  var c;
  return e instanceof lt ? n ? (e.inject(n, r), e.getName(r)) : e : be(e) ? function e(t, n) {
    var r,
      i,
      o = [];
    for (var a in t) t.hasOwnProperty(a) && !mt(t[a]) && (Array.isArray(t[a]) && t[a].isCss || xe(t[a]) ? o.push(ht(a) + ":", t[a], ";") : be(t[a]) ? o.push.apply(o, e(t[a], a)) : o.push(ht(a) + ": " + (r = a, (null == (i = t[a]) || "boolean" == typeof i || "" === i ? "" : "number" != typeof i || 0 === i || r in Z ? String(i).trim() : i + "px") + ";")));
    return n ? [n + " {"].concat(o, ["}"]) : o;
  }(e) : e.toString();
}
var gt = function gt(e) {
  return Array.isArray(e) && (e.isCss = !0), e;
};
function vt(e) {
  for (var t = arguments, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) r[i - 1] = t[i];
  return xe(e) || be(e) ? gt(pt(ye(we, [e].concat(r)))) : 0 === r.length && 1 === e.length && "string" == typeof e[0] ? e : gt(pt(ye(e, r)));
}
var yt = /invalid hook call/i,
  bt = new Set(),
  wt = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,
  Ct = /(^-|-$)/g;
function xt(e) {
  return e.replace(wt, "-").replace(Ct, "");
}
var St = function St(e) {
  return Je(Qe(e) >>> 0);
};
function kt(e) {
  return "string" == typeof e && ("production" === process.env.NODE_ENV || e.charAt(0) === e.charAt(0).toLowerCase());
}
var Nt = function Nt(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
  },
  At = function At(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
  };
function Tt(e, t, n) {
  var r = e[n];
  Nt(t) && Nt(r) ? Et(r, t) : e[n] = t;
}
function Et(e) {
  for (var t = arguments, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) r[i - 1] = t[i];
  for (var o = 0, a = r; o < a.length; o++) {
    var s = a[o];
    if (Nt(s)) for (var l in s) At(l) && Tt(e, s[l], l);
  }
  return e;
}
var Ot = r.createContext();
Ot.Consumer;
var Lt = {};
function $t(e, t, n) {
  var i = ke(e),
    o = !kt(e),
    a = t.attrs,
    s = void 0 === a ? we : a,
    l = t.componentId,
    h = void 0 === l ? function (e, t) {
      var n = "string" != typeof e ? "sc" : xt(e);
      Lt[n] = (Lt[n] || 0) + 1;
      var r = n + "-" + St("5.3.9" + n + Lt[n]);
      return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : l,
    m = t.displayName,
    p = void 0 === m ? function (e) {
      return kt(e) ? "styled." + e : "Styled(" + Se(e) + ")";
    }(e) : m,
    g = t.displayName && t.componentId ? xt(t.displayName) + "-" + t.componentId : t.componentId || h,
    v = i && e.attrs ? Array.prototype.concat(e.attrs, s).filter(Boolean) : s,
    y = t.shouldForwardProp;
  i && e.shouldForwardProp && (y = t.shouldForwardProp ? function (n, r, i) {
    return e.shouldForwardProp(n, r, i) && t.shouldForwardProp(n, r, i);
  } : e.shouldForwardProp);
  var b,
    w = new tt(n, g, i ? e.componentStyle : void 0),
    C = w.isStatic && 0 === s.length,
    x = function x(e, t) {
      return function (e, t, n, r) {
        var i = e.attrs,
          o = e.componentStyle,
          a = e.defaultProps,
          s = e.foldedComponentIds,
          l = e.shouldForwardProp,
          c = e.styledComponentId,
          h = e.target;
        "production" !== process.env.NODE_ENV && d(c);
        var m = function (e, t, n) {
            void 0 === e && (e = Ce);
            var r = ve({}, t, {
                theme: e
              }),
              i = {};
            return n.forEach(function (e) {
              var t,
                n,
                o,
                a = e;
              for (t in xe(a) && (a = a(r)), a) r[t] = i[t] = "className" === t ? (n = i[t], o = a[t], n && o ? n + " " + o : n || o) : a[t];
            }), [r, i];
          }(function (e, t, n) {
            return void 0 === n && (n = Ce), e.theme !== n.theme && e.theme || t || n.theme;
          }(t, u(Ot), a) || Ce, t, i),
          p = m[0],
          g = m[1],
          v = function (e, t, n, r) {
            var i = u(it) || at,
              o = u(ot) || st,
              a = t ? e.generateAndInjectStyles(Ce, i, o) : e.generateAndInjectStyles(n, i, o);
            return "production" !== process.env.NODE_ENV && d(a), "production" !== process.env.NODE_ENV && !t && r && r(a), a;
          }(o, r, p, "production" !== process.env.NODE_ENV ? e.warnTooManyClasses : void 0),
          y = n,
          b = g.$as || t.$as || g.as || t.as || h,
          w = kt(b),
          C = g !== t ? ve({}, t, {}, g) : t,
          x = {};
        for (var S in C) "$" !== S[0] && "as" !== S && ("forwardedAs" === S ? x.as = C[S] : (l ? l(S, K, b) : !w || K(S)) && (x[S] = C[S]));
        return t.style && g.style !== t.style && (x.style = ve({}, t.style, {}, g.style)), x.className = Array.prototype.concat(s, c, v !== c ? v : null, t.className, g.className).filter(Boolean).join(" "), x.ref = y, f(b, x);
      }(b, e, t, C);
    };
  return x.displayName = p, (b = r.forwardRef(x)).attrs = v, b.componentStyle = w, b.displayName = p, b.shouldForwardProp = y, b.foldedComponentIds = i ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : we, b.styledComponentId = g, b.target = i ? e.target : e, b.withComponent = function (e) {
    var r = t.componentId,
      i = function (e, t) {
        if (null == e) return {};
        var n,
          r,
          i = {},
          o = Object.keys(e);
        for (r = 0; r < o.length; r++) n = o[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
        return i;
      }(t, ["componentId"]),
      o = r && r + "-" + (kt(e) ? e : xt(Se(e)));
    return $t(e, ve({}, i, {
      attrs: v,
      componentId: o
    }), n);
  }, Object.defineProperty(b, "defaultProps", {
    get: function get() {
      return this._foldedDefaultProps;
    },
    set: function set(t) {
      this._foldedDefaultProps = i ? Et({}, e.defaultProps, t) : t;
    }
  }), "production" !== process.env.NODE_ENV && (function (e, t) {
    if ("production" !== process.env.NODE_ENV) {
      var n = "The component " + e + (t ? ' with the id of "' + t + '"' : "") + " has been created dynamically.\nYou may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.",
        r = console.error;
      try {
        var i = !0;
        console.error = function (e) {
          var t = arguments;
          if (yt.test(e)) i = !1, bt.delete(n);else {
            for (var o = arguments.length, a = new Array(o > 1 ? o - 1 : 0), s = 1; s < o; s++) a[s - 1] = t[s];
            r.apply(void 0, [e].concat(a));
          }
        }, c(), i && !bt.has(n) && bt.add(n);
      } catch (e) {
        yt.test(e.message) && bt.delete(n);
      } finally {
        console.error = r;
      }
    }
  }(p, g), b.warnTooManyClasses = function (e, t) {
    var n = {},
      r = !1;
    return function (e) {
      if (!r && (n[e] = !0, Object.keys(n).length >= 200)) {
        r = !0, n = {};
      }
    };
  }()), Object.defineProperty(b, "toString", {
    value: function value() {
      return "." + b.styledComponentId;
    }
  }), o && ge(b, e, {
    attrs: !0,
    componentStyle: !0,
    displayName: !0,
    foldedComponentIds: !0,
    shouldForwardProp: !0,
    styledComponentId: !0,
    target: !0,
    withComponent: !0
  }), b;
}
var Mt = function Mt(e) {
  return function e(t, n, r) {
    if (void 0 === r && (r = Ce), !Y.isValidElementType(n)) return Le(1, String(n));
    var i = function i() {
      return t(n, r, vt.apply(void 0, arguments));
    };
    return i.withConfig = function (i) {
      return e(t, n, ve({}, r, {}, i));
    }, i.attrs = function (i) {
      return e(t, n, ve({}, r, {
        attrs: Array.prototype.concat(r.attrs, i).filter(Boolean)
      }));
    }, i;
  }($t, e);
};
function It(e) {
  var t = arguments;
  "production" !== process.env.NODE_ENV && "undefined" != typeof navigator && navigator.product;
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) r[i - 1] = t[i];
  var o = vt.apply(void 0, [e].concat(r)).join(""),
    a = St(o);
  return new lt(a, o);
}
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function (e) {
  Mt[e] = Mt(e);
}), "production" !== process.env.NODE_ENV && "undefined" != typeof navigator && navigator.product, "production" !== process.env.NODE_ENV && "test" !== process.env.NODE_ENV && "undefined" != typeof window && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, window["__styled-components-init__"], window["__styled-components-init__"] += 1);
var Dt = Mt,
  Rt = Dt.ul.withConfig({
    displayName: "TimelineNavWrapper"
  })(["background:rgba(229,229,229,0.85);border-radius:25px;display:flex;list-style:none;padding:0.25em 0.25em;"]),
  Pt = Dt.li.withConfig({
    displayName: "TimelineNavItem"
  })(["padding:0.1em;display:flex;align-items:center;justify-content:center;", ";"], function (e) {
    return e.disable ? "pointer-events: none; filter: opacity(0.7)" : "";
  }),
  _t = Dt.button.withConfig({
    displayName: "TimelineNavButton"
  })(["align-items:center;background:", ";border-radius:50%;border:0;color:#fff;cursor:pointer;display:flex;filter:drop-shadow(0 0 5px rgba(0,0,0,0.25));height:20px;justify-content:center;margin:0 0.2em;padding:0;transition:all 0.1s ease-in;width:20px;transform:", ";&:active{filter:drop-shadow(0 0 2px rgba(0,0,0,0.25));transform:", " scale(0.9);}svg{width:80%;height:80%;}"], function (e) {
    return e.theme.primary;
  }, function (e) {
    if ("TRUE" === e.rotate) return "rotate(90deg)";
  }, function (e) {
    return "TRUE" === e.rotate ? "rotate(90deg)" : "";
  }),
  jt = Dt.div.withConfig({
    displayName: "TimelineControlContainer"
  })(["align-items:center;display:flex;justify-content:center;"]),
  Ht = function Ht(n) {
    var r = n.onNext,
      i = n.onPrevious,
      o = n.onFirst,
      l = n.onLast,
      c = n.disableLeft,
      d = n.disableRight,
      f = n.slideShowRunning,
      h = n.onReplay,
      m = n.slideShowEnabled,
      p = n.onToggleDarkMode,
      g = n.isDark,
      v = n.onPaused,
      y = u(S),
      b = y.mode,
      w = y.flipLayout,
      C = y.theme,
      x = y.buttonTexts,
      k = y.classNames,
      N = y.enableDarkToggle,
      A = a(function () {
        return "HORIZONTAL" !== b;
      }, [b]),
      E = a(function () {
        return w && "HORIZONTAL" === b;
      }, []),
      O = a(function () {
        return c || f;
      }, [c, f]),
      M = a(function () {
        return d || f;
      }, [d, f]),
      I = s(function () {
        f ? null == v || v() : null == h || h();
      }, [f]),
      D = a(function () {
        return w ? null == x ? void 0 : x.next : null == x ? void 0 : x.previous;
      }, [w]),
      P = a(function () {
        return w ? null == x ? void 0 : x.previous : null == x ? void 0 : x.next;
      }, [w]),
      W = a(function () {
        return f ? null == x ? void 0 : x.stop : null == x ? void 0 : x.play;
      }, [f]),
      B = a(function () {
        return w ? null == x ? void 0 : x.first : null == x ? void 0 : x.last;
      }, [w]),
      V = a(function () {
        return w ? null == x ? void 0 : x.last : null == x ? void 0 : x.first;
      }, [w]);
    return e(jt, {
      slideShowActive: f,
      flip: E,
      children: t(Rt, {
        className: T("timeline-controls", null == k ? void 0 : k.controls),
        children: [e(Pt, {
          disable: O,
          children: e(_t, {
            mode: b,
            theme: C,
            onClick: E ? l : o,
            title: V,
            "aria-label": V,
            "aria-disabled": c,
            "aria-controls": "timeline-main-wrapper",
            tabIndex: c ? -1 : 0,
            rotate: A ? "TRUE" : "FALSE",
            children: e(H, {})
          })
        }), e(Pt, {
          disable: O,
          children: e(_t, {
            mode: b,
            theme: C,
            onClick: E ? r : i,
            title: D,
            "aria-label": D,
            "aria-disabled": c,
            "aria-controls": "timeline-main-wrapper",
            tabIndex: c ? -1 : 0,
            rotate: A ? "TRUE" : "FALSE",
            children: e(L, {})
          })
        }), e(Pt, {
          disable: M,
          children: e(_t, {
            mode: b,
            theme: C,
            onClick: E ? i : r,
            title: P,
            "aria-label": P,
            "aria-disabled": d,
            "aria-controls": "timeline-main-wrapper",
            rotate: A ? "TRUE" : "FALSE",
            tabIndex: d ? -1 : 0,
            children: e($, {})
          })
        }), e(Pt, {
          disable: M,
          children: e(_t, {
            mode: b,
            theme: C,
            onClick: E ? o : l,
            title: B,
            "aria-label": B,
            "aria-disabled": d,
            "aria-controls": "timeline-main-wrapper",
            tabIndex: d ? -1 : 0,
            rotate: A ? "TRUE" : "FALSE",
            children: e(z, {})
          })
        }), e(Pt, {
          children: m && e(_t, {
            theme: C,
            onClick: I,
            title: W,
            tabIndex: 0,
            "aria-controls": "timeline-main-wrapper",
            "aria-label": W,
            children: e(f ? _ : F, {})
          })
        }), N ? e(Pt, {
          disable: f,
          children: e(_t, {
            theme: C,
            onClick: p,
            title: g ? null == x ? void 0 : x.light : null == x ? void 0 : x.dark,
            tabIndex: 0,
            "aria-controls": "timeline-main-wrapper",
            "aria-label": g ? null == x ? void 0 : x.light : null == x ? void 0 : x.dark,
            children: e(g ? j : R, {})
          })
        }) : null]
      })
    });
  };
Ht.displayName = "Timeline Control";
var zt = vt(["scrollbar-color:", " default;scrollbar-width:thin;&::-webkit-scrollbar{width:0.3em;}&::-webkit-scrollbar-track{box-shadow:inset 0 0 6px rgba(0,0,0,0.2);}&::-webkit-scrollbar-thumb{background-color:", ";outline:1px solid ", ";}"], function (e) {
    var t;
    return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
  }, function (e) {
    var t;
    return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
  }, function (e) {
    var t;
    return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
  }),
  Ft = vt(["&::after{content:'';position:absolute;bottom:0;left:0;width:100%;height:2rem;background:linear-gradient( 0deg,var(--rc-gradient-color) 0%,rgba(255,255,255,0) 100% );}"]),
  Wt = Dt.div.withConfig({
    displayName: "MediaWrapper"
  })(["align-items:flex-start;align-self:center;background:", ";border-radius:4px;flex-direction:row;height:", ";padding:0.5em;pointer-events:", ";position:relative;text-align:", ";width:calc(100% - 1em);", ";", ""], function (e) {
    var t;
    return e.textOverlay ? "none" : null === (t = e.theme) || void 0 === t ? void 0 : t.cardMediaBgColor;
  }, function (e) {
    return e.textOverlay ? "calc(100% - 1em)" : "0";
  }, function (e) {
    return !e.active && e.slideShowActive ? "none" : "";
  }, function (e) {
    return e.align;
  }, function (e) {
    return e.cardHeight ? "min-height: ".concat(e.cardHeight, "px;") : "";
  }, function (e) {
    return "HORIZONTAL" === e.mode || "left" === e.dir ? "\n        justify-content: flex-start;\n      " : "\n        justify-content: flex-end;\n      ";
  }),
  Bt = Dt.img.withConfig({
    displayName: "CardImage"
  })(["flex:4;justify-self:center;margin-left:auto;margin-right:auto;height:100%;width:100%;object-fit:", ";object-position:center;visibility:", ";border-radius:", ";"], function (e) {
    return e.fit || "cover";
  }, function (e) {
    return e.visible ? "visible" : "hidden";
  }, function (e) {
    return e.enableBorderRadius ? "6px" : "0";
  }),
  Vt = Dt.video.withConfig({
    displayName: "CardVideo"
  })(["max-width:100%;max-height:100%;margin-left:auto;margin-right:auto;"]),
  Gt = Dt.div.withConfig({
    displayName: "MediaDetailsWrapper"
  })(["bottom:0;left:0;right:0;margin-right:auto;width:", ";display:flex;flex-direction:column;flex:1;overflow:hidden;", " position:", ";", " ", " --rc-gradient-color:", ";", ""], function (e) {
    switch (e.mode) {
      case "HORIZONTAL":
      case "VERTICAL":
      case "VERTICAL_ALTERNATING":
        return "calc(90% - 0rem)";
    }
  }, function (e) {
    return e.textInMedia && e.expandFull ? vt(["height:100%;width:100%;border:0;"]) : e.showText ? e.textInMedia && e.expandable ? vt(["box-shadow:0 0 10px 0 rgba(0,0,0,0.2);border-radius:10px;height:50%;"]) : void 0 : vt(["height:15%;box-shadow:0 0 10px 0 rgba(0,0,0,0.2);border-radius:10px;"]);
  }, function (e) {
    return e.absolutePosition ? "absolute" : "relative";
  }, function (e) {
    var t, n;
    return e.absolutePosition ? "\n    left: 50%;\n    bottom: ".concat(e.expandFull ? "0%" : " 5%", ";\n    transform: translateX(-50%);\n    background: ").concat(e.showText ? null === (t = e.theme) || void 0 === t ? void 0 : t.cardDetailsBackGround : null === (n = e.theme) || void 0 === n ? void 0 : n.cardBgColor, ";\n    // backdrop-filter: blur(1px);\n    padding: 0.25rem;\n    ").concat(e.showText ? "overflow: auto;" : "overflow: hidden;", "\n    transition: height 0.25s ease-out, width 0.25s ease-out, bottom 0.25s ease-out, background 0.25s ease-out;\n  ") : "";
  }, function (e) {
    return e.borderLessCard ? "border-radius: 6px; box-shadow: 0 0 10px 0 rgba(0,0,0,0.2);" : "";
  }, function (e) {
    return e.gradientColor;
  }, function (e) {
    return e.gradientColor ? Ft : null;
  }),
  Yt = Dt.span.withConfig({
    displayName: "ErrorMessage"
  })(["color:#a3a3a3;left:50%;position:absolute;text-align:center;top:50%;transform:translateY(-50%) translateX(-50%);"]),
  Ut = Dt.iframe.withConfig({
    displayName: "IFrameVideo"
  })(["position:relative;height:100%;width:100%;"]),
  Zt = Dt.div.withConfig({
    displayName: "DetailsTextWrapper"
  })(["align-self:center;display:flex;transition:height 0.5s ease;width:calc(100%);background:", ";color:", ";padding:0.5rem;border-bottom-left-radius:8px;border-bottom-right-radius:8px;position:relative;align-items:flex-start;justify-content:center;", " ", " ", " ", ""], function (e) {
    return e.background;
  }, function (e) {
    var t;
    return null === (t = e.theme) || void 0 === t ? void 0 : t.cardDetailsColor;
  }, zt, function (e) {
    return e.expandFull ? "\n        overflow: auto;\n      " : "\n        overflow: hidden;\n      ";
  }, function (e) {
    return e.show ? "\n    height: 100%;" : "\n    height: 0;\n  ";
  }, function (e) {
    return !e.expandFull && Ft;
  }),
  qt = Dt.div.withConfig({
    displayName: "CardMediaHeader"
  })(["padding:0.5rem 0 0.5rem 0.5rem;display:flex;align-items:center;justify-content:center;"]),
  Xt = Dt.div.withConfig({
    displayName: "ImageWrapper"
  })(["width:100%;height:100%;overflow:hidden;border-radius:6px;"]),
  Jt = It(["0%{opacity:0;transform:scale(0.95);}100%{opacity:1;transform:scale(1);}"]),
  Kt = It(["0%{opacity:0;transform:translateY(-50%);}100%{opacity:1;transform:translateY(0);}"]),
  Qt = It(["0%{opacity:0;transform:translateX(-50%);}100%{opacity:1;transform:translateX(0);}"]),
  en = It(["0%{opacity:0;transform:translateX(50%);}100%{opacity:1;transform:translateX(0);}"]),
  tn = Dt.section.withConfig({
    displayName: "TimelineItemContentWrapper"
  })(["align-items:flex-start;background:", ";border-radius:4px;display:flex;position:absolute;", ";flex-direction:column;justify-content:flex-start;line-height:1.5em;margin:", ";max-width:", "px;min-height:", "px;position:relative;text-align:left;width:98%;z-index:0;", " height:", ";&:focus{outline:1px solid ", ";}", " ", ""], function (e) {
    return e.theme.cardBgColor;
  }, function (e) {
    return e.borderLessCards ? "none" : "filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.3))";
  }, function (e) {
    return "HORIZONTAL" === e.mode ? "0 auto" : "";
  }, function (e) {
    return e.maxWidth;
  }, function (e) {
    return e.minHeight;
  }, function (e) {
    return e.isNested ? vt(["background:", ";box-shadow:0 0 5px 2px rgba(0,0,0,0.1);"], e.theme.nestedCardBgColor) : vt([""]);
  }, function (e) {
    return e.textOverlay ? "0" : "";
  }, function (e) {
    var t;
    return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
  }, function (e) {
    if (e.slideShowActive && e.active) return "slide_in" === e.slideShowType ? vt(["animation:", " 0.5s ease-in-out;"], Kt) : "slide_from_sides" === e.slideShowType && "left" === e.branchDir ? vt(["animation:", " 0.5s ease-in-out;"], Qt) : "slide_from_sides" === e.slideShowType && "right" === e.branchDir ? vt(["animation:", " 0.5s ease-in-out;"], en) : vt(["animation:", " 0.5s ease-in-out;"], Jt);
  }, function (e) {
    return e.slideShowActive && e.active ? vt(["opacity:1;animation-timing-function:ease-in-out;animation-duration:0.5s;"]) : e.slideShowActive && !e.active ? vt(["opacity:0;"]) : void 0;
  }),
  nn = Dt.header.withConfig({
    displayName: "TimelineCardHeader"
  })(["width:100%;padding:0.5rem 0.5rem 0 0.5rem;"]),
  rn = Dt.h2.withConfig({
    displayName: "CardSubTitle"
  })(["color:", ";font-size:", ";font-weight:600;margin:0;text-align:left;width:97%;padding:", ";"], function (e) {
    return e.theme.cardSubtitleColor;
  }, function (e) {
    return e.fontSize;
  }, function (e) {
    return e.padding ? "0.5rem 0 0.5rem 0.5rem;" : "";
  }),
  on = Dt.h1.withConfig({
    displayName: "CardTitle"
  })(["color:", ";font-size:", ";font-weight:600;margin:0;text-align:left;width:95%;padding:", " &.active{color:", ";}"], function (e) {
    return e.theme.cardTitleColor;
  }, function (e) {
    return e.fontSize;
  }, function (e) {
    return e.padding ? "0.25rem 0 0.25rem 0.5rem;" : "";
  }, function (e) {
    return e.theme.primary;
  }),
  an = Dt.a.withConfig({
    displayName: "CardTitleAnchor"
  })(["color:inherit;&:active{color:inherit;}"]),
  sn = Dt.p.withConfig({
    displayName: "TimelineContentDetails"
  })(["font-size:0.85rem;font-weight:400;margin:0;width:100%;color:", ";"], function (e) {
    return e.theme.detailsColor;
  }),
  ln = Dt.span.withConfig({
    displayName: "TimelineSubContent"
  })(["margin-bottom:0.5rem;display:block;font-size:", ";color:", ";"], function (e) {
    return e.fontSize;
  }, function (e) {
    return e.theme.subTitleColor;
  }),
  cn = Dt.div.withConfig({
    displayName: "TimelineContentDetailsWrapper"
  })(["align-items:center;display:flex;flex-direction:column;margin:0 auto;margin-top:0.5em;margin-bottom:0.5em;position:relative;", " ", " overflow-x:hidden;overflow-y:auto;scrollbar-color:", " default;scrollbar-width:thin;transition:max-height 0.25s ease-in-out;width:", ";padding:0.25rem 0.25rem;", " &::-webkit-scrollbar{width:0.3em;}&::-webkit-scrollbar-track{box-shadow:inset 0 0 6px rgba(0,0,0,0.2);}&::-webkit-scrollbar-thumb{background-color:", ";outline:1px solid ", ";}&.show-less{scrollbar-width:none;&::-webkit-scrollbar{width:0;}overflow:hidden;}--rc-gradient-color:", ";", ""], function (e) {
    var t = e.useReadMore,
      n = e.customContent,
      r = e.showMore,
      i = e.height;
    void 0 === i && (i = 0);
    var o = e.textOverlay;
    return !t || n || r || o ? "" : "max-height: ".concat(i, "px;");
  }, function (e) {
    var t = e.cardHeight;
    void 0 === t && (t = 0);
    var n = e.contentHeight;
    void 0 === n && (n = 0);
    var r = e.height;
    void 0 === r && (r = 0);
    var i = e.showMore,
      o = e.textOverlay;
    return i && !o ? "max-height: ".concat((t || 0) + (n || 0) - r, "px;") : "";
  }, function (e) {
    var t;
    return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
  }, function (e) {
    return e.borderLess ? "calc(100% - 0.5rem)" : "calc(95% - 0.5rem)";
  }, function (e) {
    var t = e.height;
    void 0 === t && (t = 0);
    var n = e.cardHeight;
    void 0 === n && (n = 0);
    var r = e.contentHeight;
    void 0 === r && (r = 0);
    var i = e.showMore,
      o = e.useReadMore;
    return i && o && n ? vt(["animation:", " 0.25s ease-in-out;"], It(["0%{max-height:", "px;}100%{max-height:", "px;}"], t, n + r - t)) : "";
  }, function (e) {
    var t;
    return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
  }, function (e) {
    var t;
    return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
  }, function (e) {
    return e.gradientColor;
  }, Ft),
  dn = Dt.span.withConfig({
    displayName: "ShowMore"
  })(["align-items:center;align-self:flex-end;border-radius:4px;cursor:pointer;display:", ";font-size:0.75rem;justify-self:flex-end;margin-bottom:0.5em;margin-left:0.5em;margin-right:0.5em;margin-top:auto;padding:0.25em;color:", ";&:hover{text-decoration:underline;}"], function (e) {
    return e.show ? "flex" : "none";
  }, function (e) {
    return e.theme.primary;
  }),
  un = Dt.span.withConfig({
    displayName: "SlideShowProgressBar"
  })(["background:", ";bottom:-0.75em;display:block;height:4px;left:50%;transform:translateX(-50%);position:absolute;border-radius:2px;", " ", " svg{position:absolute;left:0;top:0;width:100%;}"], function (e) {
    return e.color;
  }, function (e) {
    if (e.paused) return vt(["left:50%;transform:translateX(-50%);"]);
  }, function (e) {
    return !e.paused && e.startWidth && e.startWidth > 0 ? vt(["animation:", " ", "ms ease-in;animation-play-state:running;"], It(["0%{width:", "px;}100%{width:", "px;}"], e.startWidth, 0), e.duration) : vt(["animation-play-state:paused;width:", "px;"], e.startWidth);
  }),
  fn = Dt.span.withConfig({
    displayName: "ChevronIconWrapper"
  })(["align-items:center;display:flex;height:1.25em;justify-content:center;margin-left:0.2em;margin-top:0.2em;width:1.25em;", ";svg{height:100%;width:100%;}"], function (e) {
    return e.collapsed ? "\n      transform: rotate(90deg);\n  " : "transform: rotate(-90deg)";
  }),
  hn = Dt.span.withConfig({
    displayName: "TriangleIconWrapper"
  })(["display:flex;align-items:center;justify-content:center;width:1.5rem;height:1.5rem;position:absolute;top:calc(50%);background:", ";transform:translateY(-50%) rotate(225deg);z-index:-1;& svg{width:100%;height:100%;fill:#fff;}", ";"], function (e) {
    return e.theme.cardBgColor;
  }, function (e) {
    return "left" === e.dir ? "right: ".concat(e.offset, "px;") : "left: ".concat(e.offset, "px;");
  }),
  mn = vt(["align-items:center;background:none;border-radius:50%;border:none;cursor:pointer;display:flex;height:1.5rem;justify-content:center;padding:0;width:1.5rem;margin:0 0.25rem;background:", ";color:#fff;svg{width:70%;height:70%;}"], function (e) {
    var t;
    return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
  }),
  pn = Dt.button.withConfig({
    displayName: "ExpandButton"
  })(["", ""], mn),
  gn = Dt.button.withConfig({
    displayName: "ShowHideTextButton"
  })(["", ""], mn),
  vn = Dt.ul.withConfig({
    displayName: "ButtonWrapper"
  })(["display:flex;flex-direction:row;justify-content:flex-end;list-style:none;margin:0;padding:0;margin-left:auto;"]),
  yn = function yn(t) {
    var n,
      r = t.title,
      i = t.url,
      o = t.theme,
      a = t.color,
      s = t.dir,
      l = t.active,
      c = t.fontSize;
    void 0 === c && (c = "1rem");
    var d = t.classString;
    void 0 === d && (d = "");
    var u = t.padding;
    return void 0 === u && (u = !1), r ? e(on, {
      className: T(l ? "active" : "", (n = {}, n[d] = !0, n)),
      theme: o,
      style: {
        color: a
      },
      dir: s,
      fontSize: c,
      "data-class": d,
      padding: u,
      children: i ? e(an, {
        href: i,
        target: "_blank",
        rel: "noreferrer",
        children: r
      }) : r
    }) : null;
  };
yn.displayName = "Timeline Title";
var bn = r.memo(function (t) {
  var n = t.content,
    r = t.color,
    i = t.dir,
    o = t.theme,
    a = t.fontSize,
    s = t.classString,
    l = t.padding;
  return n ? e(rn, {
    style: {
      color: r
    },
    dir: i,
    theme: o,
    fontSize: a,
    className: T("card-sub-title", s),
    padding: l,
    children: n
  }) : null;
}, function (e, t) {
  var n, r;
  return (null === (n = e.theme) || void 0 === n ? void 0 : n.cardSubtitleColor) === (null === (r = t.theme) || void 0 === r ? void 0 : r.cardSubtitleColor);
});
bn.displayName = "Timeline Content";
var wn = h(function (t) {
  var n = t.theme,
    r = t.expanded,
    i = t.onExpand,
    o = t.textOverlay,
    s = a(function () {
      return r ? "Minimize" : "Maximize";
    }, [r]);
  return o ? e(pn, {
    onPointerDown: i,
    onKeyDown: function onKeyDown(e) {
      return "Enter" === e.key && (null == i ? void 0 : i(e));
    },
    theme: n,
    "aria-expanded": r,
    tabIndex: 0,
    "aria-label": s,
    title: s,
    children: e(r ? I : M, {})
  }) : null;
}, function (e, t) {
  return e.expanded === t.expanded;
});
wn.displayName = "Expand Button";
var Cn = h(function (t) {
  var n = t.textOverlay,
    r = t.onToggle,
    i = t.theme,
    o = t.show,
    s = a(function () {
      return o ? "Hide Text" : "Show Text";
    }, [o]);
  return n ? e(gn, {
    onPointerDown: r,
    theme: i,
    tabIndex: 0,
    onKeyDown: function onKeyDown(e) {
      return "Enter" === e.key && (null == r ? void 0 : r(e));
    },
    "aria-label": s,
    title: s,
    children: e(o ? D : P, {})
  }) : null;
});
Cn.displayName = "Show Hide Text Button";
var xn = h(function (t) {
  var n = t.theme,
    r = t.show,
    i = t.expand,
    o = t.textOverlay,
    l = t.text;
  t.height;
  var c = t.onRender,
    d = s(function (e) {
      e && (null == c || c(e.clientHeight));
    }, []),
    u = a(function () {
      var e = (null == n ? void 0 : n.cardDetailsBackGround) || "";
      return e ? C(e, .8) : e;
    }, [null == n ? void 0 : n.cardDetailsBackGround]);
  return o ? e(Zt, {
    ref: d,
    expandFull: i,
    theme: n,
    show: r,
    background: u,
    children: l
  }) : null;
}, function (e, t) {
  return e.height === t.height && e.show === t.show && e.expand === t.expand && JSON.stringify(e.theme) === JSON.stringify(t.theme);
});
xn.displayName = "Details Text";
var Sn = function Sn(r) {
  var i = r.active,
    d = r.id,
    f = r.onMediaStateChange,
    m = r.title,
    p = r.content,
    g = r.media,
    v = r.slideshowActive,
    y = r.url,
    b = r.detailsText,
    w = r.showProgressBar,
    x = r.remainInterval,
    k = r.startWidth,
    N = r.paused,
    A = r.triangleDir,
    E = r.resuming,
    O = r.progressRef,
    L = c(null),
    $ = o(!1),
    M = $[0],
    I = $[1],
    D = c(null),
    R = o(0);
  R[0];
  var P = R[1],
    _ = o(!1),
    j = _[0],
    H = _[1],
    z = o(!0),
    F = z[0],
    W = z[1],
    B = o(!1),
    V = B[0],
    G = B[1],
    Y = u(S),
    U = Y.mode,
    Z = Y.fontSizes,
    q = Y.classNames,
    X = Y.mediaHeight,
    J = Y.borderLessCards,
    K = Y.textOverlay,
    Q = Y.theme,
    ee = Y.cardHeight,
    te = Y.mediaSettings;
  l(function () {
    L && (i ? L.current && L.current.play() : L.current && L.current.pause());
  }, [i]);
  var ne = s(function () {
      G(!0);
    }, []),
    re = s(function () {
      I(!0), f({
        id: d,
        paused: !1,
        playing: !1
      });
    }, [f, d]),
    ie = h(function (t) {
      var n = t.message;
      return e(Yt, {
        children: n
      });
    }),
    oe = a(function () {
      return /^(https?\:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/.test(g.source.url);
    }, []),
    ae = a(function () {
      return e(Ut, {
        frameBorder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowFullScreen: !0,
        src: "".concat(g.source.url).concat(i ? "?autoplay=1&enablejsapi=1" : "?enablejsapi=1"),
        title: g.name
      });
    }, [i]),
    se = a(function () {
      return e(Vt, {
        controls: !0,
        autoPlay: i,
        ref: L,
        onLoadedData: ne,
        "data-testid": "rc-video",
        onPlay: function onPlay() {
          return f({
            id: d,
            paused: !1,
            playing: !0
          });
        },
        onPause: function onPause() {
          return f({
            id: d,
            paused: !0,
            playing: !1
          });
        },
        onEnded: function onEnded() {
          return f({
            id: d,
            paused: !1,
            playing: !1
          });
        },
        onError: re,
        children: e("source", {
          src: g.source.url
        })
      });
    }, [i]),
    le = a(function () {
      return e(Bt, {
        src: g.source.url,
        mode: U,
        onLoad: ne,
        onError: re,
        visible: V,
        active: i,
        alt: g.name,
        loading: "lazy",
        enableBorderRadius: J,
        role: "img",
        fit: null == te ? void 0 : te.imageFit
      });
    }, [i, V, J]);
  ie.displayName = "Error Message";
  var ce = s(function (e) {
      e && P(e);
    }, []),
    de = s(function (e) {
      H(function (e) {
        return !e;
      }), W(!0);
    }, []),
    ue = s(function (e) {
      H(!1), W(function (e) {
        return !e;
      });
    }, []),
    fe = a(function () {
      return ("VERTICAL" === U || "VERTICAL_ALTERNATING" === U) && K;
    }, []),
    he = a(function () {
      return F && !!b;
    }, [F, b]),
    me = a(function () {
      return m || p || b;
    }, [m, p, b]),
    pe = a(function () {
      return K && !!b;
    }, [p, b]),
    ge = a(function () {
      return C((null == Q ? void 0 : Q.cardDetailsBackGround) || "", .8);
    }, [null == Q ? void 0 : Q.cardDetailsBackGround]),
    ve = a(function () {
      return !j && F && K;
    }, [j, F]),
    ye = a(function () {
      return K ? ee : X;
    }, []),
    be = a(function () {
      return t(Gt, {
        mode: U,
        absolutePosition: K,
        textInMedia: K,
        ref: D,
        theme: Q,
        expandFull: j,
        showText: F,
        expandable: pe,
        gradientColor: ve ? ge : null,
        children: [t(qt, {
          children: [e(yn, {
            title: m,
            theme: Q,
            active: i,
            url: y,
            fontSize: null == Z ? void 0 : Z.cardTitle,
            classString: null == q ? void 0 : q.cardTitle
          }), pe ? t(vn, {
            children: [e(Cn, {
              onToggle: ue,
              show: F,
              textOverlay: !0,
              theme: Q
            }), e(wn, {
              theme: Q,
              expanded: j,
              onExpand: de,
              textOverlay: !0
            })]
          }) : null]
        }), F && e(bn, {
          content: p,
          fontSize: null == Z ? void 0 : Z.cardSubtitle,
          classString: null == q ? void 0 : q.cardSubTitle,
          padding: !0,
          theme: Q
        }), he ? e(xn, {
          theme: Q,
          show: F,
          expand: j,
          text: b,
          onRender: ce,
          textOverlay: K
        }) : null]
      });
    }, [F, j, he, ge, m, JSON.stringify(Q)]),
    we = a(function () {
      return w && K;
    }, [w, K]);
  return t(n, {
    children: [t(Wt, {
      theme: Q,
      active: i,
      mode: U,
      slideShowActive: v,
      className: T("card-media-wrapper", null == q ? void 0 : q.cardMedia),
      cardHeight: ye,
      align: null == te ? void 0 : te.align,
      textOverlay: K,
      children: ["VIDEO" === g.type && !oe && (M ? e(ie, {
        message: "Failed to load the video"
      }) : se), "VIDEO" === g.type && oe && ae, "IMAGE" === g.type && (M ? e(ie, {
        message: "Failed to load the image."
      }) : e(Xt, {
        height: X,
        children: le
      })), we ? e(un, {
        color: null == Q ? void 0 : Q.primary,
        duration: x,
        paused: N,
        ref: O,
        startWidth: k,
        role: "progressbar",
        resuming: E
      }) : null, fe ? e(hn, {
        dir: A,
        theme: Q,
        offset: -15,
        role: "img",
        "data-testid": "arrow-icon"
      }) : null]
    }), me ? be : null]
  });
};
Sn.displayName = "Card Media";
var kn = function kn(r) {
    var i = r.showProgressBar,
      o = r.onExpand,
      s = r.triangleDir,
      l = r.showMore,
      c = r.textContentIsLarge,
      d = r.showReadMore,
      f = r.remainInterval,
      h = r.paused,
      m = r.startWidth,
      p = r.canShow,
      g = r.progressRef,
      v = r.isNested,
      y = r.isResuming,
      b = u(S),
      w = b.mode,
      C = b.theme,
      x = a(function () {
        return !v && ["VERTICAL", "VERTICAL_ALTERNATING"].some(function (e) {
          return e === w;
        });
      }, [w, v]),
      k = a(function () {
        return d && c;
      }, [d, c]);
    return t(n, {
      children: [k ? t(dn, {
        className: "show-more",
        onPointerDown: function onPointerDown(e) {
          e.stopPropagation(), e.preventDefault(), o();
        },
        onKeyPress: function onKeyPress(e) {
          "Enter" === e.key && o();
        },
        role: "button",
        show: p,
        theme: C,
        tabIndex: 0,
        children: [e("span", {
          children: l ? "read less" : "read more"
        }), e(fn, {
          collapsed: !l,
          children: e($, {})
        })]
      }) : null, i && e(un, {
        color: null == C ? void 0 : C.primary,
        duration: f,
        paused: h,
        ref: g,
        startWidth: m,
        role: "progressbar",
        resuming: y
      }), x && e(hn, {
        dir: s,
        theme: C,
        offset: -8
      })]
    });
  },
  Nn = h(function (n) {
    var r = n.title,
      i = n.url,
      o = n.media,
      a = n.content,
      s = u(S),
      l = s.fontSizes,
      c = s.classNames,
      d = s.theme;
    return t(nn, {
      children: [!o && e(yn, {
        title: r,
        theme: d,
        url: i,
        fontSize: null == l ? void 0 : l.cardTitle,
        classString: null == c ? void 0 : c.cardTitle
      }), !o && e(bn, {
        content: a,
        theme: d,
        fontSize: null == l ? void 0 : l.cardSubtitle,
        classString: null == c ? void 0 : c.cardSubTitle
      })]
    });
  });
Nn.displayName = "ContentHeader";
var An = r.memo(function (r) {
  var i = r.active,
    d = r.content,
    f = r.detailedText,
    h = r.id,
    m = r.media,
    p = r.onShowMore,
    g = r.slideShowActive,
    v = r.onElapsed,
    y = r.theme,
    b = r.title,
    w = r.onClick,
    x = r.customContent,
    k = r.hasFocus,
    N = r.flip,
    A = r.branchDir,
    E = r.url,
    O = r.timelineContent,
    L = r.items,
    $ = r.isNested,
    M = r.nestedCardHeight,
    I = o(!1),
    D = I[0],
    R = I[1],
    P = c(null),
    _ = c(null),
    j = c(null),
    H = c(0),
    z = c(0),
    F = c(0),
    W = c(),
    B = o(!1),
    V = B[0],
    G = B[1],
    Y = c(!0),
    U = o(0),
    Z = U[0],
    q = U[1],
    X = o(0),
    J = X[0],
    K = X[1],
    Q = o(!1),
    ee = Q[0],
    te = Q[1],
    ne = o(0),
    re = ne[0],
    ie = ne[1],
    oe = o(0),
    ae = oe[0],
    se = oe[1],
    le = o(!1),
    ce = le[0],
    de = le[1],
    ue = o(!1),
    fe = ue[0],
    he = ue[1],
    me = u(S),
    pe = me.mode,
    ge = me.cardHeight,
    ve = me.slideItemDuration;
  void 0 === ve && (ve = 2e3);
  var ye = me.useReadMore,
    be = me.cardWidth,
    we = me.borderLessCards,
    Ce = me.disableAutoScrollOnClick,
    xe = me.fontSizes,
    Se = me.classNames,
    ke = me.contentDetailsHeight,
    Ne = me.textOverlay,
    Ae = me.slideShowType,
    Te = me.showProgressOnSlideshow,
    Ee = a(function () {
      return i && g && Te;
    }, [i, g]),
    Oe = a(function () {
      return !!f;
    }, [f]);
  l(function () {
    var e = P.current;
    e && (e.scrollTop = 0);
  }, [D]), l(function () {
    i && de(!0);
  }, [i]);
  var Le = s(function (e) {
      if (null !== e) {
        var t = P.current;
        if (t) {
          var n = t.scrollHeight,
            r = t.offsetTop;
          H.current = e.clientWidth, K(H.current), ie(n), se(t.offsetHeight), te(n + r > e.clientHeight);
        }
      }
    }, [P.current]),
    $e = s(function (e) {
      ve && (q(e), W.current = new Date(), G(!1), F.current = window.setTimeout(function () {
        window.clearTimeout(F.current), G(!0), K(0), q(ve), h && v && v(h);
      }, e));
    }, []);
  l(function () {
    F.current && !g && window.clearTimeout(F.current);
  }, [g]);
  var Me = s(function () {
      if (i && g) {
        if (window.clearTimeout(F.current), G(!0), W.current) {
          var e = +new Date() - +W.current;
          z.current = e;
        }
        j.current && K(j.current.clientWidth);
      }
    }, [i, g]),
    Ie = s(function () {
      if (i && g) {
        if (!ve) return;
        var e = ve - z.current;
        G(!1), e > 0 && $e(e);
      }
    }, [i, g, ve]);
  l(function () {
    ve && (i && g && (K(H.current), $e(ve)), i && k && _.current && _.current.focus(), g || de(!1));
  }, [i, g]), l(function () {
    k && i && _.current && _.current.focus();
  }, [k, i]), l(function () {
    V || Y.current || he(!0);
  }, [V, J]), l(function () {
    Y.current = !1;
  }, []);
  var De = a(function () {
      return ye && f && !x;
    }, []),
    Re = s(function (e) {
      g && (e.playing ? Me() : e.paused && V && h && v && v(h));
    }, [V, g]),
    Pe = a(function () {
      return T(i ? "timeline-card-content active" : "timeline-card-content ", null == Se ? void 0 : Se.card);
    }, [i]),
    _e = a(function () {
      return T(D || x || !ye ? "card-description" : "show-less card-description", null == Se ? void 0 : Se.cardText);
    }, [D, x]),
    je = a(function () {
      return Ne && m ? ge : $ ? M : ge;
    }, []),
    He = s(function () {
      (i && V || !g) && (R(!D), p());
    }, [i, V, g, D]),
    ze = a(function () {
      return N ? "right" === A ? "left" : "right" : A;
    }, [A, N]),
    Fe = a(function () {
      var t = Array.isArray(f);
      if (O) return e("div", {
        ref: P,
        children: O
      });
      var n = null;
      return (n = t ? f.map(function (t, n) {
        return e(ln, {
          fontSize: null == xe ? void 0 : xe.cardText,
          className: null == Se ? void 0 : Se.cardText,
          theme: y,
          children: t
        }, n);
      }) : f) ? e(sn, {
        className: D ? "active" : "",
        ref: P,
        theme: y,
        children: n
      }) : null;
    }, [O, D, JSON.stringify(y)]),
    We = a(function () {
      var e = $ ? null == y ? void 0 : y.nestedCardDetailsBackGround : null == y ? void 0 : y.cardBgColor;
      return !D && ee ? C(e || "#ffffff", .8) : null;
    }, [ee, D, null == y ? void 0 : y.cardDetailsBackGround, $]),
    Be = a(function () {
      return !Ne && !(null == L ? void 0 : L.length);
    }, [null == L ? void 0 : L.length]),
    Ve = a(function () {
      return e(n, {
        children: e(cn, {
          "aria-expanded": D,
          className: _e,
          customContent: !!x,
          ref: P,
          theme: y,
          useReadMore: ye,
          borderLess: we,
          showMore: D,
          cardHeight: Ne ? null : re,
          contentHeight: ae,
          height: ke,
          textOverlay: Ne,
          gradientColor: We,
          children: x || Fe
        })
      });
    }, [D, re, ke, ae, Ne, We, y]),
    Ge = a(function () {
      if (!$) return {
        onPointerDown: function onPointerDown(e) {
          e.stopPropagation(), !g && w && h && !Ce && w(h);
        },
        onPointerEnter: Me,
        onPointerLeave: Ie
      };
    }, [Me, Ie]);
  return t(tn, Object.assign({}, {
    className: Pe,
    minHeight: je,
    maxWidth: be,
    mode: pe,
    noMedia: !m
  }, Ge, {
    ref: Le,
    tabIndex: $ ? -1 : 0,
    theme: y,
    borderLessCards: we,
    textOverlay: Ne,
    active: ce,
    slideShowType: Ae,
    slideShowActive: g,
    branchDir: A,
    isNested: $,
    children: [b && !Ne ? e(Nn, {
      title: b,
      theme: y,
      url: E,
      media: m,
      content: d
    }) : null, m && e(Sn, {
      active: i,
      cardHeight: ge,
      content: d,
      hideMedia: D,
      id: h,
      media: m,
      onMediaStateChange: Re,
      slideshowActive: g,
      theme: y,
      title: b,
      url: E,
      detailsText: Fe,
      startWidth: J,
      paused: V,
      remainInterval: Z,
      showProgressBar: Ee,
      triangleDir: ze,
      resuming: fe,
      progressRef: j
    }), Be ? Ve : e(gr, {
      items: L,
      mode: "VERTICAL",
      enableOutline: !1,
      hideControls: !0,
      nestedCardHeight: M,
      isChild: !0
    }), (!Ne || !m) && e(kn, {
      theme: y,
      progressRef: j,
      startWidth: J,
      textContentIsLarge: ee,
      remainInterval: Z,
      paused: V,
      triangleDir: ze,
      showProgressBar: Ee,
      showReadMore: De,
      onExpand: He,
      canShow: Oe,
      showMore: D,
      isNested: $,
      isResuming: fe
    })]
  }));
});
An.displayName = "TimelineCardContent";
var Tn = Dt.div.withConfig({
    displayName: "TitleWrapper"
  })(["border-radius:0.2rem;font-size:", ";font-weight:600;overflow:hidden;padding:0.25rem;visibility:", ";text-align:", ";color:", ";&.active{background:", ";color:", ";}"], function (e) {
    return e.fontSize ? e.fontSize : "1rem";
  }, function (e) {
    return e.hide ? "hidden" : "visible";
  }, function (e) {
    return e.align ? e.align : "";
  }, function (e) {
    return e.theme ? e.theme.titleColor : "";
  }, function (e) {
    var t;
    return null === (t = e.theme) || void 0 === t ? void 0 : t.secondary;
  }, function (e) {
    var t, n, r;
    return (null === (t = e.theme) || void 0 === t ? void 0 : t.titleColorActive) ? null === (n = e.theme) || void 0 === n ? void 0 : n.titleColorActive : null === (r = e.theme) || void 0 === r ? void 0 : r.primary;
  }),
  En = function En(t) {
    var n = t.title,
      r = t.active,
      i = t.theme,
      o = t.align,
      s = t.classString,
      l = a(function () {
        return T("timeline-item-title", r ? "active" : "", s);
      }, [r]),
      c = u(S).fontSizes;
    return e(Tn, {
      className: l,
      theme: i,
      hide: !n,
      align: o,
      fontSize: null == c ? void 0 : c.title,
      children: n
    });
  },
  On = Dt.div.withConfig({
    displayName: "Wrapper"
  })(["align-items:center;border:1px solid transparent;display:flex;justify-content:center;position:relative;width:100%;height:100%;&.vertical{justify-content:flex-start;}"]),
  Ln = It(["from{opacity:0;}to{opacity:1;}"]),
  $n = Dt.div.withConfig({
    displayName: "ShapeWrapper"
  })(["align-items:center;display:flex;flex-direction:column;justify-content:center;width:5em;"]),
  Mn = function Mn(e) {
    return "circle" === e.timelinePointShape ? "border-radius: 50%;" : "square" === e.timelinePointShape ? "border-radius: 2px;" : "diamond" === e.timelinePointShape ? "border-radius: 0;" : void 0;
  },
  In = Dt.div.withConfig({
    displayName: "Shape"
  })(["", " cursor:pointer;height:", "px;width:", "px;transform:", ";&.active{&.using-icon{}&:not(.using-icon){transform:", ";}&::after{", " content:'';display:block;height:", "px;width:", "px;left:50%;position:absolute;top:50%;transform:translateY(-50%) translateX(-50%);z-index:-1;}}&:not(.using-icon){background:", ";&.active{background:", ";border:", "px solid ", ";}&.in-active{}}&.using-icon{background:#fff;display:flex;align-items:center;justify-content:center;img{max-width:90%;max-height:90%;}}"], Mn, function (e) {
    return e.dimension;
  }, function (e) {
    return e.dimension;
  }, function (e) {
    return "diamond" === e.timelinePointShape ? "rotate(45deg)" : "";
  }, function (e) {
    return "diamond" === e.timelinePointShape ? "rotate(45deg)" : "";
  }, Mn, function (e) {
    return e.dimension ? Math.round(.75 * e.dimension) : 20;
  }, function (e) {
    return e.dimension ? Math.round(.75 * e.dimension) : 20;
  }, function (e) {
    var t;
    return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
  }, function (e) {
    var t;
    return null === (t = e.theme) || void 0 === t ? void 0 : t.secondary;
  }, function (e) {
    return e.dimension ? Math.round(.2 * e.dimension) : "3";
  }, function (e) {
    var t;
    return null === (t = e.theme) || void 0 === t ? void 0 : t.primary;
  }),
  Dn = Dt.div.withConfig({
    displayName: "TimelineTitleContainer"
  })(["display:flex;align-items:center;justify-content:flex-start;&.vertical{margin-bottom:1em;}&.horizontal{position:absolute;top:0;}"]),
  Rn = Dt.div.withConfig({
    displayName: "TimelineContentContainer"
  })(["align-items:flex-start;animation:", " 0.25s ease-in;outline:2px solid ", ";margin:1rem;&.horizontal{min-width:", "px;}&.vertical{width:calc(100% - 5em);margin-left:auto;flex-direction:column;}"], Ln, function (e) {
    var t;
    return e.highlight && e.active ? null === (t = e.theme) || void 0 === t ? void 0 : t.primary : "transparent";
  }, function (e) {
    return e.cardWidth;
  }),
  Pn = function Pn(n) {
    var r = n.active,
      i = n.autoScroll,
      o = n.cardDetailedText,
      d = n.cardSubtitle,
      f = n.cardTitle,
      h = n.url,
      p = n.id,
      g = n.media,
      v = n.onClick,
      y = n.onElapsed,
      b = n.slideShowRunning,
      w = n.title,
      C = n.wrapperId,
      x = n.customContent,
      k = n.hasFocus,
      N = n.iconChild,
      A = n.timelineContent,
      E = n.cardWidth,
      O = n.isNested,
      L = n.nestedCardHeight,
      $ = c(null),
      M = c(null),
      I = c(null),
      D = u(S),
      R = D.mode,
      P = D.cardPositionHorizontal,
      _ = D.timelinePointDimension,
      j = D.disableClickOnCircle,
      H = D.cardLess,
      z = D.showAllCardsHorizontal,
      F = D.classNames,
      W = D.theme,
      B = D.timelinePointShape;
    l(function () {
      if (r) {
        var e = $.current,
          t = M.current;
        if (e && t) {
          var n = e.offsetLeft,
            o = t.offsetLeft;
          null == i || i({
            pointOffset: n + o,
            pointWidth: e.clientWidth
          });
        }
      }
    }, [r, i, R]);
    var V = s(function () {}, []),
      G = a(function () {
        return null == R ? void 0 : R.toLowerCase();
      }, [R]),
      Y = a(function () {
        return T("timeline-horz-card-wrapper", G, "TOP" === P ? "bottom" : "top", z ? "show-all" : "");
      }, [R, P]),
      U = a(function () {
        return T(G, P);
      }, []),
      Z = a(function () {
        return T("timeline-circle", {
          "using-icon": !!N
        }, G, r ? "active" : "in-active");
      }, [r]),
      q = a(function () {
        return e(Rn, {
          className: Y,
          ref: I,
          id: "timeline-card-".concat(p),
          theme: W,
          active: r,
          highlight: z,
          tabIndex: 0,
          cardWidth: E,
          children: e(An, {
            content: d,
            active: r,
            title: f,
            url: h,
            detailedText: o,
            onShowMore: V,
            theme: W,
            slideShowActive: b,
            media: g,
            onElapsed: y,
            id: p,
            customContent: x,
            hasFocus: k,
            onClick: v,
            timelineContent: A,
            isNested: O,
            nestedCardHeight: L
          })
        });
      }, [r, b, JSON.stringify(W)]),
      X = a(function () {
        return r && !H || z;
      }, [r, H, z]);
    return t(On, {
      ref: M,
      className: G,
      "data-testid": "timeline-item",
      children: [X && function () {
        var e = document.getElementById(C);
        if (e) return m.createPortal(q, e);
      }(), e($n, {
        children: e(In, {
          className: Z,
          onClick: function onClick() {
            j || !v || b || v(p);
          },
          ref: $,
          "data-testid": "timeline-circle",
          theme: W,
          "aria-label": w,
          dimension: _,
          timelinePointShape: B,
          children: N || null
        })
      }), e(Dn, {
        className: U,
        "data-testid": "timeline-title",
        children: e(En, {
          title: w,
          active: r,
          theme: W,
          classString: null == F ? void 0 : F.title
        })
      })]
    });
  },
  _n = Dt.ul.withConfig({
    displayName: "TimelineHorizontalWrapper"
  })(["display:flex;list-style:none;margin:0;width:100%;direction:", ";&.vertical{flex-direction:column;}&.horizontal{flex-direction:row;}"], function (e) {
    return e.flipLayout ? "rtl" : "ltr";
  }),
  jn = Dt.li.withConfig({
    displayName: "TimelineItemWrapper"
  })(["width:", "px;visibility:hidden;display:flex;align-items:center;justify-content:center;height:150px;flex-direction:column;&.vertical{margin-bottom:2rem;width:100%;}&.visible{visibility:visible;}"], function (e) {
    return e.width;
  }),
  Hn = function Hn(t) {
    var n = t.items,
      i = t.handleItemClick,
      o = t.autoScroll,
      s = t.wrapperId,
      l = t.slideShowRunning,
      c = t.onElapsed,
      d = t.contentDetailsChildren,
      f = t.hasFocus,
      h = t.iconChildren,
      m = t.nestedCardHeight,
      p = t.isNested,
      g = u(S),
      v = g.mode;
    void 0 === v && (v = "HORIZONTAL");
    var y = g.itemWidth;
    void 0 === y && (y = 200);
    var b = g.cardHeight,
      w = g.flipLayout,
      C = g.showAllCardsHorizontal,
      x = g.theme,
      k = g.cardWidth,
      N = a(function () {
        return T(v.toLowerCase(), "timeline-horizontal-container", C ? "show-all-cards-horizontal" : "");
      }, [v, C]),
      A = r.Children.toArray(h);
    return e(_n, {
      className: N,
      flipLayout: w,
      "data-testid": "timeline-collection",
      children: n.map(function (t, n) {
        return e(jn, {
          width: y,
          className: T(t.visible ? "visible" : "", "timeline-horz-item-container"),
          children: e(Pn, Object.assign({}, t, {
            onClick: i,
            autoScroll: o,
            wrapperId: s,
            theme: x,
            slideShowRunning: l,
            cardHeight: b,
            onElapsed: c,
            customContent: d ? d[n] : null,
            hasFocus: f,
            iconChild: A[n],
            active: t.active,
            cardWidth: k,
            isNested: p,
            nestedCardHeight: m
          }))
        }, t.id);
      })
    });
  };
function zn() {
  return e("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "prefix__feather prefix__feather-x",
    children: e("path", {
      d: "M18 6L6 18M6 6l12 12"
    })
  });
}
function Fn() {
  return e("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "prefix__feather prefix__feather-menu",
    children: e("path", {
      d: "M3 12h18M3 6h18M3 18h18"
    })
  });
}
var Wn,
  Bn = It(["from{width:30px;height:30px;}to:{width:200px;height:50%;}"]),
  Vn = It(["from{width:200px;height:50%;}to:{width:30px;height:30px;}"]),
  Gn = Dt.div.withConfig({
    displayName: "OutlineWrapper"
  })(["animation:", ";animation-duration:0.2s;animation-timing-function:ease-in;background:rgba(255,255,255,0.98);border:1px solid ", ";height:50%;position:absolute;top:1rem;width:100%;z-index:9000;", ";", ";"], function (e) {
    return e.open ? Bn : Vn;
  }, function (e) {
    return e.open ? "#f5f5f5" : "none";
  }, function (e) {
    return e.position === Wn.left ? "left: 1rem;" : "right: 3rem;";
  }, function (e) {
    return e.open ? "\n    width: 200px;\n    height: 50%;\n    box-shadow: 0 5px 10px 2px rgba(0,0,0,0.2);\n    overflow-y: auto;" : "width: 30px; height: 30px;";
  }),
  Yn = Dt.aside.withConfig({
    displayName: "OutlinePane"
  })(["align-items:center;border-radius:4px;display:flex;justify-content:center;"]),
  Un = Dt.button.withConfig({
    displayName: "OutlineButton"
  })(["align-items:center;align-self:flex-end;background:#fff;border-radius:4px;border:0;box-shadow:", ";cursor:pointer;display:flex;height:30px;justify-content:center;padding:0;width:30px;", ";& svg{width:70%;height:70%;}& svg path{color:", ";}"], function (e) {
    return e.open ? "none" : "0 0 10px 2px rgba(0,0,0,0.2)";
  }, function (e) {
    return e.position === Wn.left ? "margin-right: auto;" : "margin-left: auto;";
  }, function (e) {
    return e.theme.primary;
  }),
  Zn = Dt.ul.withConfig({
    displayName: "List"
  })(["display:flex;flex-direction:column;height:100%;list-style:none;margin:0;overflow-y:auto;padding:0;width:80%;"]),
  qn = Dt.li.withConfig({
    displayName: "ListItem"
  })(["align-items:center;display:flex;font-size:0.9rem;justify-content:flex-start;margin:0.75rem 0;cursor:pointer;position:relative;&:not(:last-child)::after{content:'';display:block;width:100%;position:absolute;height:1px;background:#ddd;left:0;right:0;margin:0 auto;bottom:-50%;}"]),
  Xn = Dt.span.withConfig({
    displayName: "ListItemName"
  })(["font-size:0.75rem;color:", ";padding-left:0.25rem;&:hover{color:", ";}"], function (e) {
    return e.selected ? e.theme.primary : "";
  }, function (e) {
    return e.theme.primary;
  }),
  Jn = Dt.span.withConfig({
    displayName: "ListItemBullet"
  })(["align-items:center;display:flex;justify-content:center;margin-right:1rem;position:relative;&::after{content:'';display:block;position:absolute;width:8px;height:8px;border-radius:50%;background:", ";left:0;margin:0 auto;border:", ";}"], function (e) {
    return e.selected ? "".concat(e.theme.secondary) : "".concat(e.theme.primary);
  }, function (e) {
    return e.selected ? "2px solid ".concat(e.theme.secondary) : "2px solid ".concat(e.theme.primary);
  });
!function (e) {
  e[e.left = 0] = "left", e[e.right = 1] = "right";
}(Wn || (Wn = {}));
var Kn = function Kn(n) {
    var r = n.items;
    void 0 === r && (r = []);
    var i = n.onSelect,
      c = n.mode,
      d = o(!1),
      f = d[0],
      h = d[1],
      m = o([]),
      p = m[0],
      g = m[1],
      v = s(function () {
        return h(function (e) {
          return !e;
        });
      }, []),
      y = o(!1),
      b = y[0],
      w = y[1],
      C = u(S).theme,
      x = a(function () {
        return "VERTICAL" === c ? Wn.left : "VERTICAL_ALTERNATING" === c ? Wn.right : Wn.left;
      }, [c]);
    l(function () {
      g(r.map(function (e) {
        return Object.assign({}, e, {
          selected: !1
        });
      }));
    }, [r.length]), l(function () {
      f ? setTimeout(function () {
        w(f);
      }, 300) : w(f);
    }, [f]);
    var k = s(function (e, t) {
      g(function (e) {
        return e.map(function (e) {
          return Object.assign({}, e, {
            selected: e.id === t
          });
        });
      }), i && i(e);
    }, []);
    return t(Gn, {
      position: x,
      open: f,
      children: [e(Un, {
        onPointerDown: v,
        theme: C,
        open: f,
        position: x,
        children: e(f ? zn : Fn, {})
      }), e(Yn, {
        open: f,
        children: b && e(Zn, {
          children: p.map(function (n, r) {
            return t(qn, {
              onPointerDown: function onPointerDown() {
                return k(r, n.id);
              },
              children: [e(Jn, {
                theme: C,
                selected: n.selected
              }), e(Xn, {
                theme: C,
                selected: n.selected,
                children: n.name
              })]
            }, n.id);
          })
        })
      })]
    });
  },
  Qn = Dt.div.withConfig({
    displayName: "TimelinePointWrapper"
  })(["align-items:center;display:flex;justify-content:center;position:relative;width:", ";&.left{order:2;}&.right{order:1;}&::before{background:", ";width:", ";height:2rem;position:absolute;content:'';display:block;left:50%;top:-1rem;transform:translateY(-50%) translateX(-50%);}&::after{background:", ";content:'';display:block;height:100%;left:50%;position:absolute;width:", ";z-index:0;transform:translateX(-50%);}"], function (e) {
    return e.cardLess ? "5%" : "10%";
  }, function (e) {
    return e.bg;
  }, function (e) {
    return e.width ? "".concat(e.width, "px") : "4px";
  }, function (e) {
    return e.bg;
  }, function (e) {
    return e.width ? "".concat(e.width, "px") : "4px";
  }),
  er = Dt.div.withConfig({
    displayName: "TimelinePointContainer"
  })(["position:relative;z-index:1;"]),
  tr = h(function (t) {
    var n = t.className,
      r = t.id,
      i = t.onClick,
      o = t.active,
      s = t.onActive,
      d = t.alternateCards,
      f = t.slideShowRunning,
      h = t.iconChild,
      m = t.timelinePointDimension,
      p = t.lineWidth,
      g = t.disableClickOnCircle,
      v = t.cardLess,
      y = c(null),
      b = u(S),
      w = b.theme,
      C = b.focusActiveItemOnLoad,
      x = b.timelinePointShape,
      k = c(!0),
      N = a(function () {
        return C ? o : o && !k.current;
      }, [o]);
    l(function () {
      if (N) {
        var e = y.current;
        e && s(e.offsetTop);
      }
    }, [N, o]);
    var A = a(function () {
        return T({
          active: o,
          "using-icon": !!h
        });
      }, [o, h]),
      E = a(function () {
        return !g && {
          onClick: function onClick(e) {
            e.stopPropagation(), r && i && !f && i(r);
          }
        };
      }, []);
    return l(function () {
      k.current && (k.current = !1);
    }, []), e(Qn, {
      width: p,
      alternateCards: d,
      bg: w && w.primary,
      className: n,
      "data-testid": "tree-leaf",
      role: "button",
      cardLess: v,
      children: e(er, Object.assign({}, {
        className: "".concat(n, " timeline-vertical-circle")
      }, E, {
        ref: y,
        role: "button",
        "data-testid": "tree-leaf-click",
        "aria-label": "select timeline",
        children: e(In, {
          className: A,
          theme: w,
          dimension: m,
          timelinePointShape: x,
          children: h || null
        })
      }))
    });
  }, function (e, t) {
    return e.active === t.active;
  });
tr.displayName = "TimelinePoint";
var nr = Dt.div.withConfig({
    displayName: "TimelineVerticalWrapper"
  })(["display:flex;flex-direction:column;width:100%;padding:1em;outline:0;"]),
  rr = It(["from{opacity:0;visibility:hidden;}to{opacity:1;visibility:visible;}"]),
  ir = Dt.div.withConfig({
    displayName: "VerticalItemWrapper"
  })(["display:flex;position:relative;visibility:hidden;width:100%;align-items:stretch;justify-content:center;margin:1rem 0;&.left{margin-right:auto;}&.right{margin-left:auto;}&.visible{visibility:visible;}", ""], function (e) {
    return e.isNested ? vt(["position:relative;&:not(:last-child)::after{content:'';position:absolute;width:2px;height:2rem;background:", ";left:50%;transform:translateX(-50%);bottom:-2rem;}"], function (e) {
      return e.theme.primary;
    }) : vt([""]);
  }),
  or = Dt.div.withConfig({
    displayName: "TimelineCardContentWrapper"
  })(["visibility:hidden;position:relative;display:flex;align-items:center;", " ", " &.visible{visibility:visible;animation:", " 0.25s ease-in;}"], function (e) {
    return e.alternateCards ? "width: 50%;" : e.noTitle ? "width: 95%;" : "width: 75%;";
  }, function (e) {
    return e.flip ? "\n        justify-content: flex-end;\n        &.left {\n          order: 3;\n        }\n        &.right {\n          order: 1;\n        }\n      " : "\n        &.left {\n          order: 1;\n          justify-content: flex-end;\n        }\n        &.right {\n          order: 3;\n          justify-content: flex-start;\n        }\n      ";
  }, rr),
  ar = Dt.div.withConfig({
    displayName: "TimelineTitleWrapper"
  })(["align-items:center;display:", ";", ";&.left{justify-content:", ";order:", ";}&.right{", ";}"], function (e) {
    return e.hide && "VERTICAL" === e.mode ? "none" : "flex";
  }, function (e) {
    return e.alternateCards ? "width: 50%" : "width: 15%";
  }, function (e) {
    return e.flip ? "flex-end" : "flex-start";
  }, function (e) {
    return e.flip && "VERTICAL_ALTERNATING" === e.mode ? "1" : "3";
  }, function (e) {
    return e.flip ? "\n      order: 3;\n      justify-content: flex-start;" : "order: 1;\n    justify-content: flex-end;";
  }),
  sr = function sr(n) {
    var r,
      i = c(null),
      o = n.active,
      l = n.alternateCards,
      d = n.cardDetailedText,
      f = n.cardSubtitle,
      h = n.cardTitle,
      m = n.url,
      p = n.className,
      g = n.contentDetailsChildren,
      v = n.iconChild,
      y = n.hasFocus,
      b = n.id,
      w = n.media,
      C = n.onActive,
      x = n.onClick,
      k = n.onElapsed,
      N = n.slideShowRunning,
      A = n.title,
      E = n.visible,
      O = n.timelineContent,
      L = n.items,
      $ = n.isNested,
      M = n.nestedCardHeight,
      I = function I(e) {
        if (i.current) {
          var t = i.current,
            n = t.offsetTop,
            r = t.clientHeight;
          C(n + e, n, r);
        }
      },
      D = u(S),
      R = D.cardHeight,
      P = D.mode,
      _ = D.flipLayout,
      j = D.timelinePointDimension,
      H = D.lineWidth,
      z = D.disableClickOnCircle,
      F = D.cardLess,
      W = D.theme,
      B = D.classNames,
      V = D.textOverlay,
      G = D.mediaHeight,
      Y = s(function () {
        setTimeout(function () {
          I(0);
        }, 100);
      }, []),
      U = a(function () {
        return e(ar, {
          className: p,
          alternateCards: l,
          mode: P,
          hide: !A,
          flip: _,
          children: e(En, {
            title: A,
            active: o,
            theme: W,
            align: _ ? "left" : "right",
            classString: null == B ? void 0 : B.title
          })
        });
      }, [o]),
      Z = a(function () {
        var e;
        return T(((e = {})[p] = !0, e), "vertical-item-row", E ? "visible" : "");
      }, []),
      q = T("card-content-wrapper", E ? "visible" : "", ((r = {})[p] = !0, r)),
      X = a(function () {
        return e(tr, {
          active: o,
          alternateCards: l,
          className: p,
          id: b,
          mode: P,
          onActive: I,
          onClick: x,
          slideShowRunning: N,
          iconChild: v,
          timelinePointDimension: j,
          lineWidth: H,
          disableClickOnCircle: z,
          cardLess: F
        });
      }, [N, o]);
    return t(ir, {
      alternateCards: l,
      cardHeight: $ ? M : R,
      className: Z,
      "data-testid": "vertical-item-row",
      ref: i,
      cardLess: F,
      role: "listitem",
      isNested: $,
      theme: W,
      children: [$ ? null : U, e(or, {
        className: q,
        alternateCards: l,
        noTitle: !A,
        flip: _,
        height: V ? G : R,
        children: F ? null : e(An, {
          active: o,
          branchDir: p,
          content: f,
          customContent: g,
          detailedText: d,
          hasFocus: y,
          id: b,
          media: w,
          onClick: x,
          onElapsed: k,
          onShowMore: Y,
          slideShowActive: N,
          theme: W,
          title: h,
          url: m,
          flip: _,
          timelineContent: O,
          items: L,
          isNested: $,
          nestedCardHeight: M
        })
      }), $ ? null : X]
    }, b);
  };
sr.displayName = "VerticalItem";
var lr = function lr(n) {
  var r = n.alternateCards;
  void 0 === r && (r = !0);
  var i = n.autoScroll,
    o = n.contentDetailsChildren,
    l = n.enableOutline,
    c = n.hasFocus,
    d = n.iconChildren,
    u = n.items,
    h = n.mode,
    m = n.onClick,
    p = n.onElapsed,
    g = n.onOutlineSelection,
    v = n.slideShowRunning,
    y = n.theme,
    b = n.cardLess,
    w = n.nestedCardHeight,
    C = s(function (e, t, n) {
      i({
        contentHeight: n,
        contentOffset: t,
        pointOffset: e
      });
    }, []),
    x = s(function () {}, []),
    S = a(function () {
      return u.map(function (e) {
        return {
          id: Math.random().toString(16).slice(2),
          name: e.title
        };
      });
    }, [u.length]);
  return t(nr, {
    "data-testid": "tree-main",
    role: "list",
    children: [l && e(Kn, {
      theme: y,
      mode: h,
      items: S,
      onSelect: g
    }), u.map(function (e, t) {
      var n = "";
      n = r && t % 2 == 0 ? "left" : "right";
      var i = o && o[t] || null,
        a = Array.isArray(d) ? d[t] : 0 === t ? d : null;
      return f(sr, Object.assign({}, e, {
        alternateCards: r,
        className: n,
        contentDetailsChildren: i,
        iconChild: a,
        hasFocus: c,
        index: t,
        key: e.id,
        onActive: C,
        onClick: m,
        onElapsed: p,
        onShowMore: x,
        slideShowRunning: v,
        cardLess: b,
        nestedCardHeight: w
      }));
    })]
  });
};
lr.displayName = "TimelineVertical";
var cr = Dt.div.withConfig({
    displayName: "Wrapper"
  })(["display:flex;flex-direction:column;height:100%;&:focus{outline:0;}overflow:hidden;position:relative;user-select:none;width:100%;", ";", ";&.horizontal{justify-content:flex-start;}&.js-focus-visible :focus:not(.focus-visible){outline:0;}&.js-focus-visible .focus-visible{outline:2px solid #528deb;}"], function (e) {
    return "TOP" !== e.cardPositionHorizontal || e.hideControls ? "" : "\n    & > div:nth-of-type(1) {\n      order: 2;\n    }\n    & > div:nth-of-type(2) {\n      order: 3;\n    }\n    & > div:nth-of-type(3) {\n      order: 1;\n    }\n  ";
  }, function (e) {
    return "TOP" === e.cardPositionHorizontal && e.hideControls ? "\n    & > div:nth-of-type(1) {\n      order: 2;\n    }\n    & > div:nth-of-type(2) {\n      order: 1;\n    }\n  " : "";
  }),
  dr = Dt.div.withConfig({
    displayName: "TimelineMainWrapper"
  })(["align-items:flex-start;display:flex;justify-content:center;overflow-y:auto;overflow-x:hidden;overscroll-behavior:contain;", ";scroll-behavior:smooth;width:100%;", " &.horizontal{min-height:150px;}padding:", ";"], function (e) {
    return "HORIZONTAL" === e.mode ? "position: relative" : "";
  }, zt, function (e) {
    return e.scrollable ? "" : "0 1rem 0";
  }),
  ur = Dt.div.withConfig({
    displayName: "TimelineMain"
  })(["align-items:center;display:flex;left:0;top:50%;position:absolute;transition:all 0.2s ease;transform:translate(0,-50%);&.vertical{align-items:flex-start;height:100%;justify-content:flex-start;width:100%;}"]),
  fr = Dt.div.withConfig({
    displayName: "Outline"
  })(["background:", ";height:", ";left:0;margin-left:auto;margin-right:auto;position:absolute;right:0;width:100%;"], function (e) {
    return e.color;
  }, function (e) {
    return "".concat(e.height, "px");
  }),
  hr = Dt.div.withConfig({
    displayName: "TimelineControlContainer"
  })(["align-items:center;display:flex;justify-content:center;min-height:3rem;filter:", ";&.hide{visibility:hidden;}&.show{visibility:visible;}"], function (e) {
    return e.active ? "opacity(1);" : "opacity(0.9);";
  }),
  mr = Dt.div.withConfig({
    displayName: "TimelineContentRender"
  })(["margin-left:auto;margin-right:auto;width:98%;display:flex;align-items:flex-start;justify-content:", ";overflow-x:hidden;"], function (e) {
    return e.showAllCards ? "flex-start" : "center";
  }),
  pr = function pr(n) {
    var r = n.activeTimelineItem,
      i = n.contentDetailsChildren,
      d = n.iconChildren,
      f = n.items;
    void 0 === f && (f = []);
    var h = n.onFirst,
      m = n.onLast,
      p = n.onNext,
      g = n.onPrevious,
      v = n.onRestartSlideshow,
      y = n.onTimelineUpdated,
      b = n.onItemSelected,
      w = n.onOutlineSelection,
      C = n.slideShowEnabled,
      x = n.slideShowRunning,
      k = n.mode;
    void 0 === k && (k = "HORIZONTAL");
    var N = n.enableOutline;
    void 0 === N && (N = !1);
    var A = n.hideControls;
    void 0 === A && (A = !1);
    var L = n.nestedCardHeight,
      $ = n.isChild;
    void 0 === $ && ($ = !1);
    var M = n.onPaused,
      I = u(S),
      D = I.cardPositionHorizontal,
      R = I.disableNavOnKey,
      P = I.flipLayout,
      _ = I.itemWidth;
    void 0 === _ && (_ = 200);
    var j = I.lineWidth,
      H = I.onScrollEnd,
      z = I.scrollable;
    void 0 === z && (z = !0);
    var F = I.showAllCardsHorizontal,
      W = I.theme,
      B = I.darkMode,
      V = I.toggleDarkMode,
      G = I.verticalBreakPoint;
    void 0 === G && (G = 768);
    var Y = I.enableBreakPoint,
      U = O(k, _),
      Z = U[0],
      q = U[1],
      X = c(null),
      J = o(!1),
      K = J[0],
      Q = J[1],
      ee = c(null),
      te = o(k),
      ne = te[0],
      re = te[1],
      ie = c(null),
      oe = a(function () {
        if (!x) {
          if ("boolean" == typeof z) return z;
          if ("object" == typeof z && z.scrollbar) return z.scrollbar;
        }
      }, [x, z]),
      ae = c("react-chrono-timeline-".concat(function () {
        for (var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", t = "", n = 0; n < 7; n++) t += e.charAt(Math.floor(62 * Math.random()));
        return t;
      }()));
    E("(min-width: 100px) and (max-width: ".concat(G, "px)"), function () {
      "VERTICAL_ALTERNATING" === k && re("VERTICAL");
    }, Y), E("(min-width: ".concat(G + 1, "px)"), function () {
      re(k);
    }, Y);
    var se = s(function () {
        K && (null == p || p());
      }, [K, p]),
      le = s(function () {
        return K && (null == g ? void 0 : g());
      }, [K, g]),
      ce = s(function () {
        K && (null == h || h());
      }, [K, h]),
      de = s(function () {
        return K && (null == m ? void 0 : m());
      }, [K, m]),
      ue = s(function (e) {
        var t = e.key;
        "HORIZONTAL" === k && "ArrowRight" === t ? P ? le() : se() : "HORIZONTAL" === k && "ArrowLeft" === t ? P ? se() : le() : "VERTICAL" !== k && "VERTICAL_ALTERNATING" !== k || "ArrowDown" !== t ? "VERTICAL" !== k && "VERTICAL_ALTERNATING" !== k || "ArrowUp" !== t ? "Home" === t ? ce() : "End" === t && de() : le() : se();
      }, [se, le, de]),
      fe = function fe(e, t) {
        if (e) for (var n = 0; n < f.length; n++) if (f[n].id === e) {
          t && n < f.length - 1 ? null == y || y(n + 1) : null == y || y(n);
          break;
        }
      };
    l(function () {
      var e,
        t,
        n = f[r || 0];
      if (f.length && n && (null == b || b(n), "HORIZONTAL" === k)) {
        var i = null === (e = ee.current) || void 0 === e ? void 0 : e.querySelector("#timeline-card-".concat(n.id)),
          o = null == i ? void 0 : i.getBoundingClientRect(),
          a = null === (t = ee.current) || void 0 === t ? void 0 : t.getBoundingClientRect();
        if (o && a) {
          var s = o.width,
            l = o.left,
            c = a.width,
            d = a.left;
          setTimeout(function () {
            var e = ee.current;
            e.style.scrollBehavior = "smooth", e.scrollLeft += l - d + s / 2 - c / 2;
          }, 100);
        }
      }
    }, [r, f.length]);
    var he = function he(e) {
      var t = ie.current;
      t && q(t, e);
    };
    l(function () {
      var e = ie.current;
      e && ("HORIZONTAL" === k ? e.scrollLeft = Math.max(Z, 0) : e.scrollTop = Z);
    }, [Z]), l(function () {
      setTimeout(function () {
        var e = ie.current;
        if (e) {
          var t = e.querySelectorAll(".vertical-item-row");
          Array.from(t).forEach(function (e) {
            X.current && X.current.observe(e);
          });
        }
      }, 0);
      var e = function e(_e2, t) {
        _e2.querySelectorAll("img,video").forEach(function (e) {
          return e.style.visibility = "hide" === t ? "hidden" : "visible";
        });
      };
      return "HORIZONTAL" !== k && (X.current = new IntersectionObserver(function (t) {
        t.forEach(function (t) {
          var n = t.target;
          t.isIntersecting ? e(n, "show") : (e(n, "hide"), n.querySelectorAll("iframe").forEach(function (e) {
            var t;
            null === (t = e.contentWindow) || void 0 === t || t.postMessage('{"event":"command","func":"stopVideo","args":""}', "*");
          }));
        });
      }, {
        root: ie.current,
        threshold: 0
      })), function () {
        X.current && X.current.disconnect();
      };
    }, []);
    var me = s(function (e) {
        R || x || (Q(!0), ue(e));
      }, [R, x, ue]),
      pe = a(function () {
        return T(k.toLocaleLowerCase(), {
          "focus-visible": !$,
          "js-focus-visible": !$
        });
      }, [k, $]);
    return t(cr, {
      onKeyDown: me,
      className: pe,
      cardPositionHorizontal: D,
      onMouseDown: function onMouseDown() {
        Q(!0);
      },
      hideControls: A,
      onKeyUp: function onKeyUp(e) {
        "Escape" === e.key && (null == M || M());
      },
      children: [t(dr, {
        ref: ie,
        scrollable: oe,
        className: "".concat(k.toLowerCase(), " timeline-main-wrapper"),
        id: "timeline-main-wrapper",
        theme: W,
        mode: k,
        onScroll: function onScroll(e) {
          var t = e.target,
            n = 0;
          "VERTICAL" === k || "VERTICAL_ALTERNATING" === k ? (n = t.scrollTop + t.clientHeight, t.scrollHeight - n < 1 && (null == H || H())) : (n = t.scrollLeft + t.offsetWidth, t.scrollWidth === n && (null == H || H()));
        },
        children: ["VERTICAL_ALTERNATING" === ne ? e(lr, {
          activeTimelineItem: r,
          autoScroll: he,
          contentDetailsChildren: i,
          hasFocus: K,
          iconChildren: d,
          items: f,
          mode: ne,
          onClick: fe,
          onElapsed: function onElapsed(e) {
            return fe(e, !0);
          },
          onOutlineSelection: w,
          slideShowRunning: x,
          theme: W,
          enableOutline: N,
          nestedCardHeight: L
        }) : null, "HORIZONTAL" === ne ? t(ur, {
          className: k.toLowerCase(),
          children: [e(fr, {
            color: W && W.primary,
            height: j
          }), e(Hn, {
            autoScroll: he,
            contentDetailsChildren: i,
            handleItemClick: fe,
            hasFocus: K,
            iconChildren: d,
            items: f,
            mode: ne,
            onElapsed: function onElapsed(e) {
              return fe(e, !0);
            },
            slideShowRunning: x,
            wrapperId: ae.current,
            nestedCardHeight: L
          })]
        }) : null, "VERTICAL" === ne ? e(lr, {
          activeTimelineItem: r,
          alternateCards: !1,
          autoScroll: he,
          contentDetailsChildren: i,
          hasFocus: K,
          iconChildren: d,
          items: f,
          mode: k,
          onClick: fe,
          onElapsed: function onElapsed(e) {
            return fe(e, !0);
          },
          onOutlineSelection: w,
          slideShowRunning: x,
          theme: W,
          enableOutline: N,
          nestedCardHeight: L
        }) : null]
      }), !A && e(hr, {
        mode: k,
        children: e(Ht, {
          disableLeft: P ? r === f.length - 1 : 0 === r,
          disableRight: P ? 0 === r : r === f.length - 1,
          id: ae.current,
          onFirst: ce,
          onLast: de,
          onNext: se,
          onPrevious: le,
          onReplay: v,
          slideShowEnabled: C,
          slideShowRunning: x,
          isDark: B,
          onToggleDarkMode: V,
          onPaused: M
        })
      }), e(mr, {
        id: ae.current,
        showAllCards: F,
        ref: ee
      })]
    });
  };
pr.displayName = "Timeline";
var gr = pr,
  vr = r.Children.toArray,
  yr = function yr(t) {
    var n = t.allowDynamicUpdate;
    void 0 === n && (n = !1);
    var i = t.children,
      a = t.items,
      d = t.onScrollEnd,
      u = t.slideShow;
    void 0 === u && (u = !1);
    var f = t.onItemSelected,
      h = t.activeItemIndex;
    void 0 === h && (h = 0);
    var m = t.titleDateFormat;
    void 0 === m && (m = "MMM DD, YYYY");
    var p = t.mode,
      g = t.enableOutline,
      y = t.hideControls,
      b = o([]),
      w = b[0],
      C = b[1],
      x = c(),
      S = o(!1),
      N = S[0],
      A = S[1],
      T = o(h),
      E = T[0],
      O = T[1],
      L = function L(e) {
        if (e && e.length) return e.map(function (e, t) {
          var n,
            r = Math.random().toString(16).slice(2);
          return Object.assign({}, e, {
            _dayjs: v(e.date),
            active: t === h,
            id: r,
            items: null === (n = e.items) || void 0 === n ? void 0 : n.map(function (e) {
              return Object.assign({}, e, {
                _dayjs: v(e.date),
                id: Math.random().toString(16).slice(2),
                isNested: !0,
                visible: !0
              });
            }),
            title: e.date ? v(e.date).format(m) : e.title,
            visible: !0
          });
        });
        var t = r.Children.toArray(i).filter(function (e) {
          return "chrono-icons" !== e.props.className;
        }).length;
        return Array.from({
          length: t
        }).map(function (e, t) {
          return {
            active: t === h,
            id: Math.random().toString(16).slice(2),
            visible: !0
          };
        });
      };
    l(function () {
      var e = null == a ? void 0 : a.filter(function (e) {
          return e;
        }),
        t = [];
      if (null == e ? void 0 : e.length) w.length && e.length > w.length ? t = function (e) {
        if (e) {
          var t = w.length;
          return e.map(function (e, n) {
            return Object.assign({}, e, {
              active: n === t,
              id: Math.random().toString(16).slice(2),
              visible: !0
            });
          });
        }
        return [];
      }(e) : e.length && (t = L(e)), t.length && (x.current = t, C(t));else {
        var n = L();
        C(n);
      }
    }, [JSON.stringify(n ? a : null)]);
    var $ = s(function (e) {
      C(function (t) {
        return t.map(function (t, n) {
          return Object.assign({}, t, {
            active: n === e,
            visible: e >= 0
          });
        });
      }), O(e), a && a.length - 1 === e && A(!1);
    }, []);
    l(function () {
      $(h);
    }, [h]);
    var M = s(function () {
        $(-1), setTimeout(function () {
          A(!0), $(0);
        }, 0);
      }, []),
      I = s(function (e) {
        e >= 0 && (O(e), $(e));
      }, [w.length]),
      D = s(function () {
        A(!1);
      }, []),
      R = vr(i).filter(function (e) {
        return "chrono-icons" === e.props.className;
      });
    return R.length && (R = R[0].props.children), e(k, Object.assign({}, t, {
      children: e(gr, {
        activeTimelineItem: E,
        contentDetailsChildren: vr(i).filter(function (e) {
          return "chrono-icons" !== e.props.className;
        }),
        iconChildren: R,
        items: w,
        onFirst: function onFirst() {
          O(0), $(0);
        },
        onLast: function onLast() {
          if (w.length) {
            var e = w.length - 1;
            O(e), $(e);
          }
        },
        onNext: function onNext() {
          if (w.length && E < w.length - 1) {
            var e = E + 1;
            $(e), O(e);
          }
        },
        onPrevious: function onPrevious() {
          if (E > 0) {
            var e = E - 1;
            $(e), O(e);
          }
        },
        onRestartSlideshow: M,
        onTimelineUpdated: $,
        slideShow: u,
        slideShowEnabled: u,
        slideShowRunning: N,
        onScrollEnd: d,
        onItemSelected: f,
        onOutlineSelection: I,
        mode: p,
        enableOutline: g,
        hideControls: y,
        onPaused: D
      })
    }));
  };
export { yr as Chrono };